"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4732],{

/***/ 53402:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ ScrollableContent; },
/* harmony export */   "w": function() { return /* binding */ ShadowedScrollableContent; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(87379);
/* harmony import */ var simplebar_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14863);
/* harmony import */ var polished__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(17573);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(81041);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(14332);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var react_hook_inview__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69671);
/* harmony import */ var src_utils_casePathEmptyString__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(12732);
/* harmony import */ var react_t7e__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(17739);
/* harmony import */ var react_t7e__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(react_t7e__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var src_components_icons_ChevronBottom__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(56647);
/* harmony import */ var src_utils_motion_transitions__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(84176);
/* harmony import */ var src_hooks_useMediaQuery__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(10763);
/* harmony import */ var src_styles_designs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(73098);
/* harmony import */ var react_use__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(48286);
/* harmony import */ var src_hooks_useDelayedValue__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(12230);





function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  & > .simplebar-track.simplebar-vertical {\n    width: 11rpx;\n    right: -6rpx;\n    background: none !important;\n\n    &:before {\n      content: '';\n      position: absolute;\n      top: 0;\n      left: 6rpx;\n      bottom: 0;\n      right: 0;\n      width: 1rpx;\n    }\n\n    .simplebar-scrollbar {\n      pointer-events: all;\n      width: 11rpx;\n\n      &:before {\n        transition: left 0.1s ease-in, width 0.1s ease-in;\n        width: 1rpx;\n        left: 6rpx;\n        right: 0;\n        top: 0;\n        bottom: 0;\n        border-radius: 0;\n        opacity: 1;\n      }\n    }\n\n    &:before {\n      background: ",
        ";\n    }\n\n    .simplebar-scrollbar {\n      &:before {\n        background: ",
        ";\n      }\n    }\n  }\n\n  & > .simplebar-track.simplebar-vertical.simplebar-hover,\n  &.simplebar-dragging .simplebar-track.simplebar-vertical {\n    .simplebar-scrollbar {\n      &:before {\n        width: 5rpx;\n        left: 4rpx;\n      }\n    }\n  }\n\n  & .simplebar-content {\n    // Safari ghost scrollbar fix\n    & > :first-child {\n      overflow: hidden;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    &::before {\n      opacity: 0.7;\n    }\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    &::after {\n      opacity: 0.7;\n    }\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  &::before,\n  &::after {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    width: 100%;\n    height: 40px;\n    transition: 0.25s;\n    pointer-events: none;\n\n    opacity: 0;\n    background: linear-gradient(0deg, rgba(51, 51, 51, 0) 0%, #333333 81.47%);\n  }\n\n  &::after {\n    top: auto;\n    bottom: 0;\n    background: linear-gradient(180deg, rgba(51, 51, 51, 0) 0%, #333333 81.47%);\n  }\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  bottom: 20px;\n  left: 50%;\n  transform: translateX(-50%);\n\n  display: flex;\n  align-items: center;\n  gap: 4px;\n\n  font-size: 11px;\n  text-transform: uppercase;\n  font-weight: 500;\n  padding: 6px 12px;\n\n  border-radius: 30px;\n  background: #000;\n  color: ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}















var ScrollableContent = (0,styled_components__WEBPACK_IMPORTED_MODULE_10__["default"])((0,framer_motion__WEBPACK_IMPORTED_MODULE_11__/* .motion */ .E)(/*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_3__.forwardRef)(function ScrollableContent(props, ref) {
    // Replaces ref to a SimpleBar instance with a ref to an HTMLElement, so StyledSimpleBar
    // will be compatible with framer-motion
    var innerRef = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        if (typeof ref === "function") {
            var _$ref;
            ref(((_$ref = innerRef.current) === null || _$ref === void 0 ? void 0 : _$ref.el) || null);
        } else if (ref) {
            var _$ref1;
            ref.current = ((_$ref1 = innerRef.current) === null || _$ref1 === void 0 ? void 0 : _$ref1.el) || null;
        }
    }, [
        innerRef.current
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(simplebar_react__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, props), {
        ref: innerRef
    }));
}))).withConfig({
    displayName: "ScrollableContent",
    componentId: "sc-5b11a56f-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return (0,polished__WEBPACK_IMPORTED_MODULE_14__/* .transparentize */ .DZ)(0.7, theme.palette.gray4);
}, function(param) {
    var theme = param.theme;
    return theme.palette.contrastToBackground;
});
var StyledScrollableContent = (0,styled_components__WEBPACK_IMPORTED_MODULE_10__["default"])(ScrollableContent).withConfig({
    displayName: "ScrollableContent__StyledScrollableContent",
    componentId: "sc-5b11a56f-1"
})(_templateObject3(), (0,src_utils_casePathEmptyString__WEBPACK_IMPORTED_MODULE_5__/* .casePathEmptyString */ .Q)("$isOverflowingTop")((0,styled_components__WEBPACK_IMPORTED_MODULE_10__.css)(_templateObject1())), (0,src_utils_casePathEmptyString__WEBPACK_IMPORTED_MODULE_5__/* .casePathEmptyString */ .Q)("$isOverflowingBottom")((0,styled_components__WEBPACK_IMPORTED_MODULE_10__.css)(_templateObject2())));
var Indicator = (0,styled_components__WEBPACK_IMPORTED_MODULE_10__["default"])(framer_motion__WEBPACK_IMPORTED_MODULE_11__/* .motion.span */ .E.span).attrs((0,src_utils_motion_transitions__WEBPACK_IMPORTED_MODULE_7__/* .makeTransition */ .Vr)({
    fade: true
})).withConfig({
    displayName: "ScrollableContent__Indicator",
    componentId: "sc-5b11a56f-2"
})(_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.text.palette.primary;
});
var ShadowedScrollableContent = function(_param) {
    var children = _param.children, _indicator = _param.indicator, indicator = _indicator === void 0 ? true : _indicator, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(_param, [
        "children",
        "indicator"
    ]);
    var _ = (0,react_t7e__WEBPACK_IMPORTED_MODULE_16__.useTranslate)()._;
    var isMobile = (0,src_hooks_useMediaQuery__WEBPACK_IMPORTED_MODULE_17__/* .useMediaQuery */ .a)(src_styles_designs__WEBPACK_IMPORTED_MODULE_8__/* .media.w.lessThan.desktop */ .BC.w.lessThan.desktop);
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)((0,react_hook_inview__WEBPACK_IMPORTED_MODULE_4__/* .useInView */ .Y)(), 2), intersectionTopRef = ref[0], isTopVisible = ref[1];
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)((0,react_hook_inview__WEBPACK_IMPORTED_MODULE_4__/* .useInView */ .Y)(), 2), intersectionBottomRef = ref1[0], isBottomVisible = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(indicator && !isBottomVisible), indicatorVisible = ref2[0], setIndicatorVisible = ref2[1];
    (0,react_use__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)(function() {
        if (indicatorVisible && (!isTopVisible || isBottomVisible)) {
            setIndicatorVisible(false);
        }
    }, [
        isTopVisible,
        isBottomVisible
    ]);
    var indicatorVisibleDelayed = (0,src_hooks_useDelayedValue__WEBPACK_IMPORTED_MODULE_9__/* .useDelayedValue */ .t)(indicatorVisible, 500, false);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledScrollableContent, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({
        $isOverflowingTop: !isTopVisible,
        $isOverflowingBottom: !isBottomVisible
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                ref: intersectionTopRef
            }),
            children,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_20__/* .AnimatePresence */ .M, {
                children: indicatorVisibleDelayed && indicatorVisible && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Indicator, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_components_icons_ChevronBottom__WEBPACK_IMPORTED_MODULE_6__/* .ChevronBottom */ .B, {
                            size: 11
                        }),
                        " ",
                        _(isMobile ? "SWIPE" : "SCROLL")
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                ref: intersectionBottomRef
            })
        ]
    }));
};


/***/ }),

/***/ 44732:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Oh": function() { return /* binding */ NeauviaMiniplayerPlayer; },
  "l9": function() { return /* binding */ NeauviaPlayer; },
  "jT": function() { return /* binding */ NeauviaPlayerLayer; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs
var _inherits = __webpack_require__(28668);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 3 modules
var _create_super = __webpack_require__(26626);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./src/styles/common.ts
var common = __webpack_require__(12258);
// EXTERNAL MODULE: ./src/styles/theme.ts + 3 modules
var theme = __webpack_require__(68251);
// EXTERNAL MODULE: ./node_modules/react-t7e/lib/index.js
var lib = __webpack_require__(17739);
// EXTERNAL MODULE: ./src/styles/designs.ts
var designs = __webpack_require__(73098);
// EXTERNAL MODULE: ./src/components/player/common.tsx
var player_common = __webpack_require__(33578);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 6 modules
var polished_esm = __webpack_require__(17573);
;// CONCATENATED MODULE: ./src/components/player/overlays/BigCircledUnmute.tsx




var BigCircledUnmute = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: "131",
        height: "131",
        viewBox: "0 0 131 131",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "65.5",
                cy: "65.5",
                r: "65",
                stroke: "currentColor",
                strokeWidth: "1"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M75.2638 34V97L52.0898 78.9758H34.9844V52.0242H52.0898L75.2638 34ZM70.525 43.689L53.7157 56.7629H39.7231V74.2371H53.7157L70.525 87.311V43.689Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M86.3618 56.4658V74.5323H81.623V56.4658H86.3618Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M95.2466 52.0234V78.9751H90.5078V52.0234H95.2466Z",
                        fill: "currentColor"
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ var overlays_BigCircledUnmute = (BigCircledUnmute);

// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion.mjs + 109 modules
var motion = __webpack_require__(81041);
// EXTERNAL MODULE: ./src/utils/motion/transitions.ts
var transitions = __webpack_require__(84176);
;// CONCATENATED MODULE: ./src/components/player/overlays/UnmuteOverlay.tsx



function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        svg {\n          width: 50px;\n          height: 50px;\n        }\n      "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        " {\n    ",
        "\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 100%;\n\n  z-index: ",
        ";\n  display: flex;\n  flex-direction: row;\n  gap: 20px;\n  justify-content: center;\n  align-items: center;\n  transition: color ease-out 0.2s, transform ease-out 0.2s;\n  cursor: pointer;\n  padding: 20px 40px;\n  font-weight: 600;\n  transform: scale(1);\n\n  color: ",
        ";\n\n  &:hover {\n    color: ",
        ";\n    transform: scale(1.05);\n  }\n\n  font-size: 21px;\n  line-height: 110%;\n\n  text-align: center;\n  letter-spacing: 0.02em;\n\n  ",
        " {\n    flex-direction: column;\n    font-size: 14px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 131px;\n  height: 131px;\n\n  ",
        " {\n    width: 70px;\n    height: 70px;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}











var Container = (0,styled_components_browser_esm["default"])(player_common/* OverlayLayerCentered */.f4).attrs({
    "data-no-focus-mode": false
}).withConfig({
    displayName: "UnmuteOverlay__Container",
    componentId: "sc-33b485d4-0"
})(_templateObject1(), designs/* media.w.lessThan.desktop */.BC.w.lessThan.desktop, function(param) {
    var $iconOnly = param.$iconOnly;
    return $iconOnly && (0,styled_components_browser_esm.css)(_templateObject());
});
var Unmute = (0,styled_components_browser_esm["default"])(motion/* motion.div */.E.div).withConfig({
    displayName: "UnmuteOverlay__Unmute",
    componentId: "sc-33b485d4-1"
})(_templateObject2(), player_common/* playerFadeZIndex */.PO - 2, (0,theme/* fromTheme */.HW)(function(t) {
    return (0,polished_esm/* transparentize */.DZ)(0.2, t.text.palette.heavy);
}), (0,theme/* fromTheme */.HW)(function(t) {
    return t.text.palette.heavy;
}), designs/* media.w.lessThan.desktop */.BC.w.lessThan.desktop);
var StyledBigUnmute = (0,styled_components_browser_esm["default"])(overlays_BigCircledUnmute).withConfig({
    displayName: "UnmuteOverlay__StyledBigUnmute",
    componentId: "sc-33b485d4-2"
})(_templateObject3(), designs/* media.w.lessThan.desktop */.BC.w.lessThan.desktop);
var UnmuteOverlay = /*#__PURE__*/ (0,react.memo)(function UnmuteOverlay(param) {
    var onUnmute = param.onUnmute, iconOnly = param.iconOnly;
    var _ = (0,lib.useTranslate)()._;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
        className: "player__mute-overlay",
        onClick: onUnmute,
        $iconOnly: !!iconOnly,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Unmute, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,transitions/* makeTransition */.Vr)({
            fade: true,
            speed: "faster"
        })), {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBigUnmute, {}),
                !iconOnly && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: _("Click to unmute")
                })
            ]
        }))
    });
});

// EXTERNAL MODULE: ./src/modules/materials/components/UserActions/index.tsx + 2 modules
var UserActions = __webpack_require__(34966);
// EXTERNAL MODULE: ./src/modules/user/utils/permissions.ts
var permissions = __webpack_require__(96117);
// EXTERNAL MODULE: ./src/modules/videos/models/index.ts
var models = __webpack_require__(24897);
;// CONCATENATED MODULE: ./src/components/player/overlays/UserActionsOverlay.tsx

function UserActionsOverlay_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0;\n  top: 16px;\n  right: 16px;\n\n  ",
        " {\n    top: 22px;\n    right: 40px;\n    gap: 16px;\n  }\n"
    ]);
    UserActionsOverlay_templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var StyledUserActions = (0,styled_components_browser_esm["default"])(UserActions/* UserActions */.E).withConfig({
    displayName: "UserActionsOverlay__StyledUserActions",
    componentId: "sc-6ed9f681-0"
})(UserActionsOverlay_templateObject(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var UserActionsOverlay = /*#__PURE__*/ (0,react.memo)(function UserActionsOverlay(param) {
    var video = param.video, _allowMiniplayer = param.allowMiniplayer, allowMiniplayer = _allowMiniplayer === void 0 ? true : _allowMiniplayer, _allowShare = param.allowShare, allowShare = _allowShare === void 0 ? true : _allowShare, onShareOpen = param.onShareOpen, onOpenMiniplayer = param.onOpenMiniplayer;
    var ref, ref1;
    var canFavourite = ((ref = video.source) === null || ref === void 0 ? void 0 : ref.format) === models/* VideoFormat.Wistia */.Z.Wistia;
    var canMiniplayer = allowMiniplayer && (0,permissions/* canUserAccessItem */.k)(video);
    var canShare = !!(allowShare && (!(0,permissions/* canUserAccessItem */.k)(video) || ((ref1 = video.source) === null || ref1 === void 0 ? void 0 : ref1.format) === models/* VideoFormat.Wistia */.Z.Wistia));
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledUserActions, {
        item: video,
        onShareOpen: canShare ? onShareOpen : undefined,
        onOpenMiniplayer: canMiniplayer ? onOpenMiniplayer : undefined,
        favouriteButton: canFavourite
    });
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_extends.mjs
var _extends = __webpack_require__(40872);
// EXTERNAL MODULE: ./src/components/common/ShareOverlay.tsx + 5 modules
var common_ShareOverlay = __webpack_require__(52575);
;// CONCATENATED MODULE: ./src/components/player/overlays/ShareOverlay.tsx



function ShareOverlay_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  z-index: ",
        ";\n"
    ]);
    ShareOverlay_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var ShareOverlay_Container = (0,styled_components_browser_esm["default"])(player_common/* OverlayLayer */.s2).withConfig({
    displayName: "ShareOverlay__Container",
    componentId: "sc-e5e0661b-0"
})(ShareOverlay_templateObject(), player_common/* playerOverlayAboveControlsZIndex */._R);
var ShareOverlay = /*#__PURE__*/ (0,react.memo)(function ShareOverlay(_param) {
    var props = (0,_extends/* default */.Z)({}, _param);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareOverlay_Container, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_ShareOverlay/* ShareOverlay */.Hs, (0,_object_spread/* default */.Z)({}, props))
    });
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./src/components/TrackedLink.tsx
var TrackedLink = __webpack_require__(79017);
// EXTERNAL MODULE: ./src/components/common/Button/index.tsx + 8 modules
var Button = __webpack_require__(78296);
// EXTERNAL MODULE: ./src/components/icons/ChevronLeft.tsx
var ChevronLeft = __webpack_require__(18709);
// EXTERNAL MODULE: ./src/hooks/useMediaQuery.ts
var useMediaQuery = __webpack_require__(10763);
// EXTERNAL MODULE: ./src/hooks/directus/useTranslateItem.ts
var useTranslateItem = __webpack_require__(70057);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./src/services/route.ts + 1 modules
var route = __webpack_require__(38325);
;// CONCATENATED MODULE: ./src/components/player/overlays/TitleOverlay.tsx




function TitleOverlay_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 16px;\n  left: 16px;\n  right: 0;\n  max-width: 60%;\n  pointer-events: none;\n\n  ",
        " {\n    top: 20px;\n    left: 40px;\n  }\n\n  opacity: 1;\n  transition: opacity ",
        "s\n    ",
        ";\n"
    ]);
    TitleOverlay_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function TitleOverlay_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  pointer-events: none !important;\n"
    ]);
    TitleOverlay_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function TitleOverlay_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 12px;\n  pointer-events: all;\n  ",
        " {\n    direction: rtl !important;\n  }\n"
    ]);
    TitleOverlay_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function TitleOverlay_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-style: normal;\n  font-weight: 300;\n  font-size: 24px;\n  line-height: 36px;\n  pointer-events: none !important;\n\n  letter-spacing: 0.02em;\n  color: ",
        ";\n\n  ",
        " {\n    display: none;\n  }\n"
    ]);
    TitleOverlay_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
















var VideoTitleContainer = (0,styled_components_browser_esm["default"])(player_common/* OverlayLayer */.s2).withConfig({
    displayName: "TitleOverlay__VideoTitleContainer",
    componentId: "sc-8f14c934-0"
})(TitleOverlay_templateObject(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop, (0,theme/* fromTheme */.HW)(function(t) {
    return t.animation.duration;
}), (0,theme/* fromTheme */.HW)(function(t) {
    return t.animation.easing.accelerated;
}));
var StyledMotionDiv = (0,styled_components_browser_esm["default"])(motion/* motion.div */.E.div).withConfig({
    displayName: "TitleOverlay__StyledMotionDiv",
    componentId: "sc-8f14c934-1"
})(TitleOverlay_templateObject1());
var BackButton = (0,styled_components_browser_esm["default"])(Button/* Button */.zx).withConfig({
    displayName: "TitleOverlay__BackButton",
    componentId: "sc-8f14c934-2"
})(TitleOverlay_templateObject2(), theme/* dirRTL */.gX);
var VideoTitle = (0,styled_components_browser_esm["default"])(motion/* motion.h1 */.E.h1).withConfig({
    displayName: "TitleOverlay__VideoTitle",
    componentId: "sc-8f14c934-3"
})(TitleOverlay_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.text.palette.heavy;
}, designs/* media.w.lessThan.desktop */.BC.w.lessThan.desktop);
var transition = (0,transitions/* makeTransition */.Vr)({
    fade: true,
    speed: "faster"
});
var _obj;
var backHrefConfigMap = (_obj = {}, (0,_define_property/* default */.Z)(_obj, route/* Route.VideosMain */.AW.VideosMain, {
    title: "Back to Medical Education",
    href: route/* Route.VideosMain */.AW.VideosMain
}), (0,_define_property/* default */.Z)(_obj, route/* Route.ExpertZoneMain */.AW.ExpertZoneMain, {
    title: "Back to files list",
    href: route/* Route.ExpertZoneMain */.AW.ExpertZoneMain
}), _obj);
var TitleOverlay = /*#__PURE__*/ (0,react.memo)(function(param) {
    var video = param.video, backHref = param.backHref;
    var _ = (0,lib.useTranslate)()._;
    var translateItem = (0,useTranslateItem/* useTranslateItem */.L)();
    var isDesktop = (0,useMediaQuery/* useMediaQuery */.a)(designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
    var previous = (0,es/* useSelector */.v9)(function(s) {
        return s.app.previousRoute;
    });
    var back = (0,react.useMemo)(function() {
        if (backHref) {
            if (typeof backHref === "string") {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, backHrefConfigMap[route/* Route.VideosMain */.AW.VideosMain]), {
                    href: backHref
                });
            }
            var ref;
            return (ref = previous && backHrefConfigMap[previous.route]) !== null && ref !== void 0 ? ref : backHrefConfigMap[route/* Route.VideosMain */.AW.VideosMain];
        }
        return null;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        backHref
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoTitleContainer, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledMotionDiv, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, transition), {
            children: [
                back && /*#__PURE__*/ (0,jsx_runtime.jsx)(TrackedLink/* TrackedLink */.A, {
                    href: back.href,
                    passHref: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BackButton, {
                        forwardedAs: "a",
                        kind: "rounded",
                        size: isDesktop ? "default" : "small",
                        icon: ChevronLeft/* ChevronLeft */.s,
                        children: _(back.title)
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoTitle, {
                    children: translateItem(video).name
                })
            ]
        }))
    });
});
TitleOverlay.displayName = "TitleOverlay";

// EXTERNAL MODULE: ./src/modules/videos/components/VideoSummary.tsx + 1 modules
var VideoSummary = __webpack_require__(45522);
;// CONCATENATED MODULE: ./src/components/player/overlays/VideoSummaryOverlay.tsx



function VideoSummaryOverlay_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  opacity: 0;\n  width: 220px;\n  background: linear-gradient(to left, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.4));\n  position: absolute;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  padding: 50px 30px;\n  transition: all ",
        "s\n    ",
        ";\n  transform: translateX(-100%);\n"
    ]);
    VideoSummaryOverlay_templateObject = function _templateObject() {
        return data;
    };
    return data;
}








var VideoSummaryContainer = (0,styled_components_browser_esm["default"])(motion/* motion.div */.E.div).withConfig({
    displayName: "VideoSummaryOverlay__VideoSummaryContainer",
    componentId: "sc-43ba791b-0"
})(VideoSummaryOverlay_templateObject(), (0,theme/* fromTheme */.HW)(function(t) {
    return t.animation.duration / 2;
}), (0,theme/* fromTheme */.HW)(function(t) {
    return t.animation.easing.accelerated;
}));
var VideoSummaryOverlay = /*#__PURE__*/ (0,react.memo)(function VideoSummaryOverlay(param) {
    var video = param.video;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(player_common/* OverlayLayer */.s2, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoSummaryContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,transitions/* makeTransition */.Vr)({
            fade: true,
            speed: "faster"
        })), {
            className: "np-overlay__video-summary",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoSummary/* VideoSummary */.C, {
                video: video,
                moreButton: false
            })
        }))
    });
});

// EXTERNAL MODULE: ./vendor/mods/styled-components/index.tsx
var styled_components = __webpack_require__(10395);
// EXTERNAL MODULE: ./src/components/player/overlays/HealthcareLegalConsentOverlay.tsx
var HealthcareLegalConsentOverlay = __webpack_require__(97113);
// EXTERNAL MODULE: ./src/hooks/useUserHealthcareLegalConsent.ts
var useUserHealthcareLegalConsent = __webpack_require__(32962);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36305);
;// CONCATENATED MODULE: ./src/components/player/overlays/ShortcodesOverlay/common.tsx

function common_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          left: 0;\n        "
    ]);
    common_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function common_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          right: 0;\n        "
    ]);
    common_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function common_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  bottom: 70px;\n  font-family: ",
        ";\n  ",
        "\n\n  ",
        " {\n    bottom: 49px;\n  }\n"
    ]);
    common_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



var defaultDuration = 5;
var durationByType = {
    contact: defaultDuration,
    link: defaultDuration,
    label: defaultDuration,
    video: defaultDuration
};
var shortcodeCommonLayout = (0,styled_components_browser_esm.css)(common_templateObject2(), (0,theme/* fromTheme */.HW)(function(a) {
    return a.text.font.primary;
}), function(param) {
    var $location = param.$location;
    return $location === "left" ? (0,styled_components_browser_esm.css)(common_templateObject()) : (0,styled_components_browser_esm.css)(common_templateObject1());
}, designs/* media.w.lessThan.desktop */.BC.w.lessThan.desktop);

// EXTERNAL MODULE: ./vendor/hooks/useStream.ts
var useStream = __webpack_require__(6436);
// EXTERNAL MODULE: ./node_modules/rambda/dist/rambda.esm.js
var rambda_esm = __webpack_require__(49713);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/components/AnimatePresence/index.mjs + 2 modules
var AnimatePresence = __webpack_require__(14332);
// EXTERNAL MODULE: ./src/components/icons/ChevronRight.tsx
var ChevronRight = __webpack_require__(38108);
;// CONCATENATED MODULE: ./src/components/player/overlays/ShortcodesOverlay/ShortcodeLink.tsx



function ShortcodeLink_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n            background: linear-gradient(\n              -90deg,\n              rgba(16, 16, 16, 0.7) 23.32%,\n              rgba(47, 47, 47, 0) 134.05%\n            );\n          "
    ]);
    ShortcodeLink_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ShortcodeLink_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n            background: linear-gradient(\n              270deg,\n              rgba(16, 16, 16, 0.7) 23.32%,\n              rgba(47, 47, 47, 0) 134.05%\n            );\n          "
    ]);
    ShortcodeLink_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ShortcodeLink_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  && {\n    ",
        ";\n    text-transform: none;\n    font-weight: 500;\n    font-size: 16px;\n    line-height: 21px;\n    letter-spacing: 0;\n    color: ",
        ";\n    backdrop-filter: blur(12px);\n    padding: 14px 20px 14px 25px;\n\n    ",
        "\n\n    svg {\n      margin-left: 14px;\n      height: 24px;\n      width: 24px;\n    }\n\n    ",
        " {\n      font-size: 10px;\n      line-height: 12px;\n      padding: 9px;\n\n      svg {\n        margin-left: 14px;\n        height: 16px;\n        width: 16px;\n      }\n    }\n  }\n"
    ]);
    ShortcodeLink_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}











var ShortcodeLinkContainer = (0,motion/* motion */.E)((0,styled_components_browser_esm["default"])(Button/* Button */.zx).withConfig({
    displayName: "ShortcodeLink__ShortcodeLinkContainer",
    componentId: "sc-e0072542-0"
})(ShortcodeLink_templateObject2(), shortcodeCommonLayout, function(param) {
    var theme = param.theme;
    return theme.text.palette.primary;
}, function(param) {
    var $location = param.$location;
    return $location === "left" ? (0,styled_components_browser_esm.css)(ShortcodeLink_templateObject()) : (0,styled_components_browser_esm.css)(ShortcodeLink_templateObject1());
}, designs/* media.w.lessThan.desktop */.BC.w.lessThan.desktop));
function ShortcodeLink(props) {
    var _shortcode = props.shortcode, link_url = _shortcode.link_url, link_title = _shortcode.link_title, location = _shortcode.location;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
        target: "_blank",
        href: link_url,
        rel: "noreferrer",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_components/* Theme */.Q, {
            theme: theme/* darkTheme */.$_,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ShortcodeLinkContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                layout: true
            }, (0,transitions/* makeTransition */.Vr)({
                fade: true,
                from: location === "left" ? "left" : "right",
                speed: "slow"
            })), {
                $location: location,
                kind: "text",
                children: [
                    link_title,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronRight/* ChevronRight */._, {})
                ]
            }))
        })
    });
}

// EXTERNAL MODULE: ./vendor/mods/markdown/components/Markdown.tsx
var Markdown = __webpack_require__(15201);
// EXTERNAL MODULE: ./src/components/icons/Close.tsx
var Close = __webpack_require__(34039);
// EXTERNAL MODULE: ./src/modules/modals/components/common.tsx
var components_common = __webpack_require__(47573);
// EXTERNAL MODULE: ./src/components/common/DispatchOnClick.tsx
var DispatchOnClick = __webpack_require__(94565);
;// CONCATENATED MODULE: ./src/components/player/overlays/ShortcodesOverlay/ShortcodeContact.tsx



function ShortcodeContact_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          background: linear-gradient(\n            -90deg,\n            rgba(16, 16, 16, 0.7) 23.32%,\n            rgba(47, 47, 47, 0) 134.98%\n          );\n        "
    ]);
    ShortcodeContact_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ShortcodeContact_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          background: linear-gradient(\n            270deg,\n            rgba(16, 16, 16, 0.7) 23.32%,\n            rgba(47, 47, 47, 0) 134.98%\n          );\n        "
    ]);
    ShortcodeContact_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ShortcodeContact_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n  display: grid;\n  grid-template-areas: 'header close' 'content content';\n  grid-template-columns: 1fr auto;\n  grid-template-rows: auto auto;\n  grid-auto-flow: row;\n  grid-gap: 18px;\n  text-transform: none;\n\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 16px;\n  letter-spacing: 0;\n  color: ",
        ";\n  padding: 22px 28px 28px;\n\n  ",
        "\n  backdrop-filter: blur(12px);\n\n  ",
        " {\n    font-size: 10px;\n    line-height: 12px;\n    grid-template-areas: 'header' 'content';\n    grid-template-columns: 1fr;\n    padding: 13px 20px 16px;\n    grid-gap: 13px;\n\n    ",
        " {\n      min-width: 157px;\n    }\n  }\n"
    ]);
    ShortcodeContact_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ShortcodeContact_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-area: close;\n  position: relative;\n  font-size: 10px !important;\n\n  ",
        " {\n    display: none;\n  }\n"
    ]);
    ShortcodeContact_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-area: header;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-area: content;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}















var ShortcodeContactContainer = (0,motion/* motion */.E)(styled_components_browser_esm["default"].div.withConfig({
    displayName: "ShortcodeContact__ShortcodeContactContainer",
    componentId: "sc-84c1730f-0"
})(ShortcodeContact_templateObject2(), shortcodeCommonLayout, function(param) {
    var theme = param.theme;
    return theme.text.palette.primary;
}, function(param) {
    var $location = param.$location;
    return $location === "left" ? (0,styled_components_browser_esm.css)(ShortcodeContact_templateObject()) : (0,styled_components_browser_esm.css)(ShortcodeContact_templateObject1());
}, designs/* media.w.lessThan.desktop */.BC.w.lessThan.desktop, Button/* ButtonContainer */.qO));
var CloseButton = (0,styled_components_browser_esm["default"])(Button/* Button */.zx).withConfig({
    displayName: "ShortcodeContact__CloseButton",
    componentId: "sc-84c1730f-1"
})(ShortcodeContact_templateObject3(), designs/* media.w.lessThan.desktop */.BC.w.lessThan.desktop);
var Header = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ShortcodeContact__Header",
    componentId: "sc-84c1730f-2"
})(_templateObject4());
var Content = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ShortcodeContact__Content",
    componentId: "sc-84c1730f-3"
})(_templateObject5());
function ShortcodeContact(props) {
    var _ = (0,lib.useTranslate)()._;
    var location = props.shortcode.location;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_components/* Theme */.Q, {
        theme: theme/* darkTheme */.$_,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ShortcodeContactContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            layout: true
        }, (0,transitions/* makeTransition */.Vr)({
            fade: true,
            from: location === "left" ? "left" : "right",
            speed: "slow"
        })), {
            $location: location,
            kind: "text",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Header, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Markdown/* Markdown */.U, {
                        children: _("Contact our Neauvia expert")
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_common/* CloseModalWrapper */.Bq, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseButton, {
                        kind: "text",
                        icon: Close/* Close */.x
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Content, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DispatchOnClick/* DispatchOnClick */.Q, {
                        type: "modalOpen",
                        payload: {
                            kind: "contact"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.zx, {
                            as: "a",
                            variant: "primary",
                            target: "_blank",
                            children: _("contact me")
                        })
                    })
                })
            ]
        }))
    });
}

// EXTERNAL MODULE: ./src/components/common/FormatDate.tsx
var FormatDate = __webpack_require__(23955);
;// CONCATENATED MODULE: ./src/components/player/overlays/ShortcodesOverlay/ShortcodeLabel.tsx



function ShortcodeLabel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n            padding: 14px 70px 14px 25px;\n            text-align: left;\n            background: linear-gradient(\n              to right,\n              ",
        " 25.11%,\n              ",
        " 97.65%\n            );\n            -webkit-mask-image: linear-gradient(\n              to right,\n              rgba(0, 0, 0, 1) calc(100% - 70px),\n              rgba(0, 0, 0, 0) 100%\n            );\n\n            ",
        " {\n              padding: 9px;\n              padding-right: 45px;\n              -webkit-mask-image: linear-gradient(\n                to left,\n                rgba(0, 0, 0, 1) calc(100% - 45px),\n                rgba(0, 0, 0, 0) 100%\n              );\n            }\n          "
    ]);
    ShortcodeLabel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ShortcodeLabel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n            padding: 14px 25px 14px 70px;\n            text-align: right;\n            background: linear-gradient(\n              to left,\n              ",
        " 25.11%,\n              ",
        " 97.65%\n            );\n            -webkit-mask-image: linear-gradient(\n              to left,\n              rgba(0, 0, 0, 1) calc(100% - 70px),\n              rgba(0, 0, 0, 0) 100%\n            );\n\n            ",
        " {\n              padding: 9px;\n              padding-left: 45px;\n              -webkit-mask-image: linear-gradient(\n                to left,\n                rgba(0, 0, 0, 1) calc(100% - 45px),\n                rgba(0, 0, 0, 0) 100%\n              );\n            }\n          "
    ]);
    ShortcodeLabel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ShortcodeLabel_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  && {\n    ",
        ";\n    display: grid;\n    grid-auto-flow: row;\n    text-transform: none;\n    font-weight: 500;\n    font-size: 16px;\n    line-height: 21px;\n    letter-spacing: 0;\n    color: ",
        ";\n\n    ",
        "\n\n    backdrop-filter: blur(12px);\n  }\n"
    ]);
    ShortcodeLabel_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ShortcodeLabel_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: bold;\n  font-size: 18px;\n  line-height: 27px;\n\n  ",
        " {\n    font-size: 10px;\n    line-height: 12px;\n  }\n"
    ]);
    ShortcodeLabel_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function ShortcodeLabel_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 21px;\n\n  ",
        " {\n    font-size: 10px;\n    line-height: 12px;\n  }\n  time {\n    margin-right: 4px;\n    font-weight: 400;\n  }\n"
    ]);
    ShortcodeLabel_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}












var ShortcodeLabelContainer = (0,motion/* motion */.E)(styled_components_browser_esm["default"].div.withConfig({
    displayName: "ShortcodeLabel__ShortcodeLabelContainer",
    componentId: "sc-991d163a-0"
})(ShortcodeLabel_templateObject2(), shortcodeCommonLayout, function(param) {
    var theme = param.theme;
    return theme.text.palette.primary;
}, function(param) {
    var $location = param.$location;
    return $location === "left" ? (0,styled_components_browser_esm.css)(ShortcodeLabel_templateObject(), function(param) {
        var theme = param.theme;
        return theme.palette.accent;
    }, function(param) {
        var theme = param.theme;
        return (0,polished_esm/* transparentize */.DZ)(1, theme.palette.accent);
    }, designs/* media.w.lessThan.desktop */.BC.w.lessThan.desktop) : (0,styled_components_browser_esm.css)(ShortcodeLabel_templateObject1(), function(param) {
        var theme = param.theme;
        return theme.palette.accent;
    }, function(param) {
        var theme = param.theme;
        return (0,polished_esm/* transparentize */.DZ)(1, theme.palette.accent);
    }, designs/* media.w.lessThan.desktop */.BC.w.lessThan.desktop);
}));
var ShortcodeLabelTitle = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ShortcodeLabel__ShortcodeLabelTitle",
    componentId: "sc-991d163a-1"
})(ShortcodeLabel_templateObject3(), designs/* media.w.lessThan.desktop */.BC.w.lessThan.desktop);
var ShortcodeLabelDescription = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ShortcodeLabel__ShortcodeLabelDescription",
    componentId: "sc-991d163a-2"
})(ShortcodeLabel_templateObject4(), designs/* media.w.lessThan.desktop */.BC.w.lessThan.desktop);
function ShortcodeLabel(props) {
    var _shortcode = props.shortcode, label_title = _shortcode.label_title, label_description = _shortcode.label_description, location = _shortcode.location;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_components/* Theme */.Q, {
        theme: theme/* redTheme */.MN,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ShortcodeLabelContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            layout: true,
            onClick: function(e) {
                e.preventDefault();
                e.stopPropagation();
            }
        }, (0,transitions/* makeTransition */.Vr)({
            fade: true,
            from: location === "left" ? "left" : "right",
            speed: "slow"
        })), {
            $location: location,
            kind: "text"
        }), props), {
            children: [
                label_title ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ShortcodeLabelTitle, {
                    className: "shortcodelabel__title",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Markdown/* Markdown */.U, {
                        children: label_title
                    })
                }) : null,
                label_description ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ShortcodeLabelDescription, {
                    className: "shortcodelabel__description",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Markdown/* Markdown */.U, {
                        Hour: function(param) {
                            var children = param.children;
                            return Array.isArray(children) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(FormatDate/* FormatHour */.t, {
                                children: children[0]
                            }) : null;
                        },
                        children: label_description
                    })
                }) : null
            ]
        }))
    });
}

;// CONCATENATED MODULE: ./src/components/player/overlays/ShortcodesOverlay/ShortcodeUpcomingVideo.tsx



function ShortcodeUpcomingVideo_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 6px 15px 11px 60px !important;\n  && {\n    .shortcodelabel__title {\n      text-align: left;\n      font-weight: 400;\n      font-size: 12px;\n      line-height: 21px;\n      text-transform: uppercase;\n    }\n    .shortcodelabel__description {\n      text-align: left;\n      font-size: 14px;\n      line-height: 16px;\n      font-weight: 300;\n      max-width: 100%;\n      ",
        ";\n    }\n  }\n  ",
        " {\n    padding: 6px 15px 11px 70px !important;\n    max-width: 60%;\n  }\n"
    ]);
    ShortcodeUpcomingVideo_templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var StyledShortcodeLabel = (0,styled_components_browser_esm["default"])(ShortcodeLabel).withConfig({
    displayName: "ShortcodeUpcomingVideo__StyledShortcodeLabel",
    componentId: "sc-94bdd2d2-0"
})(ShortcodeUpcomingVideo_templateObject(), (0,common/* lineClamp */.Sf)(1), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
function ShortcodeUpcomingVideo(props) {
    var _ = (0,lib.useTranslate)()._;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledShortcodeLabel, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        shortcode: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props.shortcode), {
            label_title: _("Next")
        })
    }));
}

// EXTERNAL MODULE: ./src/modules/materials/components/Thumbnail/index.tsx + 6 modules
var Thumbnail = __webpack_require__(87847);
// EXTERNAL MODULE: ./vendor/mods/media-breakpoints-fresnel/components/Media.tsx
var Media = __webpack_require__(50696);
;// CONCATENATED MODULE: ./src/components/player/overlays/ShortcodesOverlay/ShortcodeVideo.tsx



function ShortcodeVideo_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          background: linear-gradient(\n            -90deg,\n            rgba(16, 16, 16, 0.7) 23.32%,\n            rgba(47, 47, 47, 0) 134.98%\n          );\n        "
    ]);
    ShortcodeVideo_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ShortcodeVideo_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          background: linear-gradient(\n            270deg,\n            rgba(16, 16, 16, 0.7) 23.32%,\n            rgba(47, 47, 47, 0) 134.98%\n          );\n        "
    ]);
    ShortcodeVideo_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ShortcodeVideo_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n  display: grid;\n  grid-template-areas: 'header close' 'content content';\n  grid-template-columns: 1fr auto;\n  grid-template-rows: auto auto;\n  grid-auto-flow: row;\n  grid-gap: 18px;\n  text-transform: none;\n  width: 264px;\n  box-sizing: content-box;\n\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 16px;\n  letter-spacing: 0;\n  color: ",
        ";\n  padding: 22px 28px 28px;\n\n  ",
        "\n\n  backdrop-filter: blur(12px);\n\n  ",
        " {\n    width: 306px;\n    grid-template-columns: 1fr 30px;\n    grid-template-areas: 'header space' 'content space';\n    padding: 8px;\n    font-size: 10px;\n    line-height: 12px;\n    grid-gap: 7px;\n  }\n"
    ]);
    ShortcodeVideo_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ShortcodeVideo_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-area: close;\n  position: relative;\n  font-size: 10px !important;\n\n  ",
        " {\n    position: absolute !important;\n    top: 25px;\n    right: 14px;\n\n    svg {\n      width: 16px !important;\n      height: 16px !important;\n    }\n  }\n"
    ]);
    ShortcodeVideo_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function ShortcodeVideo_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-area: header;\n"
    ]);
    ShortcodeVideo_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function ShortcodeVideo_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-area: content;\n"
    ]);
    ShortcodeVideo_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
















var ShortcodeVideoContainer = (0,motion/* motion */.E)(styled_components_browser_esm["default"].div.withConfig({
    displayName: "ShortcodeVideo__ShortcodeVideoContainer",
    componentId: "sc-556b7e70-0"
})(ShortcodeVideo_templateObject2(), shortcodeCommonLayout, function(param) {
    var theme = param.theme;
    return theme.text.palette.primary;
}, function(param) {
    var $location = param.$location;
    return $location === "left" ? (0,styled_components_browser_esm.css)(ShortcodeVideo_templateObject()) : (0,styled_components_browser_esm.css)(ShortcodeVideo_templateObject1());
}, designs/* media.w.lessThan.desktop */.BC.w.lessThan.desktop));
var ShortcodeVideo_CloseButton = (0,styled_components_browser_esm["default"])(Button/* Button */.zx).withConfig({
    displayName: "ShortcodeVideo__CloseButton",
    componentId: "sc-556b7e70-1"
})(ShortcodeVideo_templateObject3(), designs/* media.w.lessThan.desktop */.BC.w.lessThan.desktop);
var ShortcodeVideo_Header = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ShortcodeVideo__Header",
    componentId: "sc-556b7e70-2"
})(ShortcodeVideo_templateObject4());
var ShortcodeVideo_Content = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ShortcodeVideo__Content",
    componentId: "sc-556b7e70-3"
})(ShortcodeVideo_templateObject5());
function ShortcodeVideo(props) {
    var _ = (0,lib.useTranslate)()._;
    var _shortcode = props.shortcode, location = _shortcode.location, video_video = _shortcode.video_video;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_components/* Theme */.Q, {
        theme: theme/* darkTheme */.$_,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ShortcodeVideoContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            layout: true
        }, (0,transitions/* makeTransition */.Vr)({
            fade: true,
            from: location === "left" ? "left" : "right",
            speed: "slow"
        })), {
            $location: location,
            kind: "text",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ShortcodeVideo_Header, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Markdown/* Markdown */.U, {
                        children: _("Combined video", "shortcodes")
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_common/* CloseModalWrapper */.Bq, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShortcodeVideo_CloseButton, {
                        kind: "text",
                        icon: Close/* Close */.x
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ShortcodeVideo_Content, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Media/* MediaDirect */.UT, {
                            greaterThanOrEqual: "desktop",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Thumbnail/* Thumbnail */.$, {
                                item: video_video,
                                showUserActions: false,
                                showLock: false
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Media/* MediaDirect */.UT, {
                            lessThan: "desktop",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Thumbnail/* Thumbnail */.$, {
                                item: video_video,
                                variant: "small",
                                showUserActions: false
                            })
                        })
                    ]
                })
            ]
        }))
    });
}

// EXTERNAL MODULE: ./src/components/common/PimImage.tsx
var PimImage = __webpack_require__(43573);
// EXTERNAL MODULE: ./src/modules/products/hooks/useProductDetailsQuery.ts
var useProductDetailsQuery = __webpack_require__(63281);
;// CONCATENATED MODULE: ./src/components/player/overlays/ShortcodesOverlay/ShortcodeProducts/ShortcodeSingleProduct.tsx

function ShortcodeSingleProduct_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  display: grid;\n  grid-template-areas: 'header button' 'content button';\n  grid-gap: 1px;\n  padding: 7px 6px 5px 14px;\n  ",
        " {\n    grid-gap: 10px;\n    grid-template-areas: '. header' '. content' '. button';\n    padding: 20px 32px 23px 80px;\n  }\n"
    ]);
    ShortcodeSingleProduct_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ShortcodeSingleProduct_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-area: content;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 21px;\n  color: ",
        ";\n  max-width: 165px;\n  white-space: initial !important;\n  ",
        ";\n\n  ",
        " {\n    font-size: 10px;\n    line-height: 13px;\n    ",
        ";\n  }\n"
    ]);
    ShortcodeSingleProduct_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ShortcodeSingleProduct_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-area: header;\n  font-weight: 500;\n  text-transform: uppercase;\n"
    ]);
    ShortcodeSingleProduct_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ShortcodeSingleProduct_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  && {\n    grid-area: button;\n    background: ",
        ";\n    border-color: ",
        ";\n    height: 42px;\n    min-width: 165px;\n    max-width: 165px;\n    margin-top: 10px;\n    &:hover {\n      background: transparent !important;\n    }\n    ",
        " {\n      display: none;\n    }\n  }\n"
    ]);
    ShortcodeSingleProduct_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function ShortcodeSingleProduct_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 30%;\n  transform: translate(-50%, -30%);\n  left: 0;\n  width: 24px;\n  height: 63px;\n  ",
        " {\n    top: 0;\n    left: 42px;\n    transform: translate(-50%, 0);\n    width: 81px;\n    height: 209px;\n    max-height: 110%;\n  }\n  & > div {\n    overflow: visible;\n  }\n"
    ]);
    ShortcodeSingleProduct_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function ShortcodeSingleProduct_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-area: button;\n  margin-left: 5px;\n  padding: 5px 10px;\n  width: 30px;\n  height: 30px;\n  color: ",
        ";\n  ",
        " {\n    display: none;\n  }\n"
    ]);
    ShortcodeSingleProduct_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}












var ShortcodeProductSingleWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ShortcodeSingleProduct__ShortcodeProductSingleWrapper",
    componentId: "sc-736e3fe0-0"
})(ShortcodeSingleProduct_templateObject(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var ShortcodelDescription = styled_components_browser_esm["default"].p.withConfig({
    displayName: "ShortcodeSingleProduct__ShortcodelDescription",
    componentId: "sc-736e3fe0-1"
})(ShortcodeSingleProduct_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.text.palette.primary;
}, (0,common/* lineClamp */.Sf)(6), designs/* media.w.lessThan.desktop */.BC.w.lessThan.desktop, (0,common/* lineClamp */.Sf)(3));
var ShortcodeHeading = (0,styled_components_browser_esm["default"])(ShortcodelDescription).attrs({
    as: "h3"
}).withConfig({
    displayName: "ShortcodeSingleProduct__ShortcodeHeading",
    componentId: "sc-736e3fe0-2"
})(ShortcodeSingleProduct_templateObject2());
var ShortcodeButton = (0,styled_components_browser_esm["default"])(Button/* Button */.zx).attrs({
    forwardedAs: "a"
}).withConfig({
    displayName: "ShortcodeSingleProduct__ShortcodeButton",
    componentId: "sc-736e3fe0-3"
})(ShortcodeSingleProduct_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.palette.accent;
}, function(param) {
    var theme = param.theme;
    return theme.palette.accent;
}, designs/* media.w.lessThan.desktop */.BC.w.lessThan.desktop);
var ShortcodeImage = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ShortcodeSingleProduct__ShortcodeImage",
    componentId: "sc-736e3fe0-4"
})(ShortcodeSingleProduct_templateObject4(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var ArrowButton = (0,styled_components_browser_esm["default"])(Button/* CleanButton */.ux).withConfig({
    displayName: "ShortcodeSingleProduct__ArrowButton",
    componentId: "sc-736e3fe0-5"
})(ShortcodeSingleProduct_templateObject5(), function(param) {
    var theme = param.theme;
    return theme.text.palette.primary;
}, designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var ShortcodeSingleProduct = function(param) {
    var productPimCode = param.productPimCode;
    var _ = (0,lib.useTranslate)()._;
    var translateFn = (0,useTranslateItem/* useTranslateItem */.L)();
    var ref = (0,useProductDetailsQuery/* useProductDetailsQuery */.c)(productPimCode), product = ref.data;
    if (!product || !product.image) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ShortcodeProductSingleWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ShortcodeImage, {
                children: product.image && /*#__PURE__*/ (0,jsx_runtime.jsx)(PimImage/* PimImage */.o, {
                    src: product.image.id,
                    layout: "fill",
                    objectFit: "contain"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ShortcodeHeading, {
                children: translateFn(product).name
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ShortcodelDescription, {
                children: translateFn(product).description_short
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TrackedLink/* TrackedLink */.A, {
                href: route/* route.products */.BC.products().page(product),
                passHref: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShortcodeButton, {
                    children: _("featured product", "shortcodes")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TrackedLink/* TrackedLink */.A, {
                href: route/* route.products */.BC.products().page(product),
                passHref: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowButton, {
                    as: "a",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronRight/* ChevronRight */._, {
                        size: 16
                    })
                })
            })
        ]
    }, product.code);
};

;// CONCATENATED MODULE: ./src/components/player/overlays/ShortcodesOverlay/ShortcodeProducts/ShortcodeMultiProduct.tsx

function ShortcodeMultiProduct_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n"
    ]);
    ShortcodeMultiProduct_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ShortcodeMultiProduct_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  display: grid;\n  grid-template-areas: 'image content';\n  padding: 8px 10px 8px;\n  grid-gap: 8px;\n  flex: 0 0 auto;\n\n  ",
        " {\n    grid-template-areas: 'image' 'content';\n    padding: 16px 4px 21px 11px;\n  }\n  &:not(:last-child) {\n    &:after {\n      content: '';\n      position: absolute;\n      top: 50%;\n      right: 2px;\n      width: 1px;\n      height: 50%;\n      opacity: 0.2;\n      transform: translateY(-50%);\n      background: ",
        ";\n    }\n  }\n"
    ]);
    ShortcodeMultiProduct_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ShortcodeMultiProduct_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-area: content;\n  font-weight: 400;\n  font-size: 13px;\n  line-height: 18px;\n  color: ",
        ";\n  width: 95px;\n  white-space: initial !important;\n  ",
        ";\n\n  ",
        " {\n    font-size: 10px;\n    line-height: 12px;\n    width: 70px;\n    margin: auto;\n  }\n"
    ]);
    ShortcodeMultiProduct_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ShortcodeMultiProduct_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  grid-area: image;\n  width: 16px;\n  height: 44px;\n  ",
        " {\n    width: auto;\n    height: 70px;\n    margin: 0 10px;\n  }\n"
    ]);
    ShortcodeMultiProduct_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}









var ShortcodeProductMultiWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ShortcodeMultiProduct__ShortcodeProductMultiWrapper",
    componentId: "sc-9a92204c-0"
})(ShortcodeMultiProduct_templateObject());
var ShordcodeProduct = styled_components_browser_esm["default"].a.withConfig({
    displayName: "ShortcodeMultiProduct__ShordcodeProduct",
    componentId: "sc-9a92204c-1"
})(ShortcodeMultiProduct_templateObject1(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop, function(param) {
    var theme = param.theme;
    return theme.text.palette.primary;
});
var ShortcodeMultiProduct_ShortcodelDescription = styled_components_browser_esm["default"].p.withConfig({
    displayName: "ShortcodeMultiProduct__ShortcodelDescription",
    componentId: "sc-9a92204c-2"
})(ShortcodeMultiProduct_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.text.palette.primary;
}, (0,common/* lineClamp */.Sf)(4), designs/* media.w.lessThan.desktop */.BC.w.lessThan.desktop);
var ShortcodeMultiProduct_ShortcodeImage = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ShortcodeMultiProduct__ShortcodeImage",
    componentId: "sc-9a92204c-3"
})(ShortcodeMultiProduct_templateObject3(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var ShortcodeMultiProductItem = function(param) {
    var productPimCode = param.productPimCode;
    var translateFn = (0,useTranslateItem/* useTranslateItem */.L)();
    var ref = (0,useProductDetailsQuery/* useProductDetailsQuery */.c)(productPimCode), product = ref.data;
    if (!product || !product.image) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TrackedLink/* TrackedLink */.A, {
        href: route/* route.products */.BC.products().page(product),
        passHref: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ShordcodeProduct, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ShortcodeMultiProduct_ShortcodeImage, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PimImage/* PimImage */.o, {
                        src: product.image.id,
                        layout: "fill",
                        objectFit: "contain"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ShortcodeMultiProduct_ShortcodelDescription, {
                    children: translateFn(product).description_short
                })
            ]
        })
    });
};
var ShortcodeMultiProduct = function(param) {
    var products = param.products;
    var children = products.map(function(product) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ShortcodeMultiProductItem, {
            productPimCode: product.products_id.pim_code
        }, product.id);
    });
    if (children.every(function(c) {
        return c === null;
    })) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ShortcodeProductMultiWrapper, {
        children: children
    });
};

;// CONCATENATED MODULE: ./src/components/player/overlays/ShortcodesOverlay/ShortcodeProducts/index.tsx



function ShortcodeProducts_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      max-width: 90%;\n      overflow: auto;\n    "
    ]);
    ShortcodeProducts_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ShortcodeProducts_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          background: linear-gradient(\n            -90deg,\n            rgba(16, 16, 16, 0.7) 23.32%,\n            rgba(47, 47, 47, 0) 134.98%\n          );\n        "
    ]);
    ShortcodeProducts_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ShortcodeProducts_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          background: linear-gradient(\n            270deg,\n            rgba(16, 16, 16, 0.7) 23.32%,\n            rgba(47, 47, 47, 0) 134.98%\n          );\n        "
    ]);
    ShortcodeProducts_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ShortcodeProducts_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      padding-left: 15px;\n      ",
        " {\n        padding-left: 40px;\n      }\n    "
    ]);
    ShortcodeProducts_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function ShortcodeProducts_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n  ",
        "\n\n  backdrop-filter: blur(12px);\n  ",
        "\n  ",
        "\n"
    ]);
    ShortcodeProducts_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}











var ShortcodeProductsContainer = (0,motion/* motion */.E)(styled_components_browser_esm["default"].div.withConfig({
    displayName: "ShortcodeProducts__ShortcodeProductsContainer",
    componentId: "sc-c6d22d86-0"
})(ShortcodeProducts_templateObject4(), shortcodeCommonLayout, function(param) {
    var $single = param.$single;
    return !$single && (0,styled_components_browser_esm.css)(ShortcodeProducts_templateObject());
}, function(param) {
    var $location = param.$location;
    return $location === "left" ? (0,styled_components_browser_esm.css)(ShortcodeProducts_templateObject1()) : (0,styled_components_browser_esm.css)(ShortcodeProducts_templateObject2());
}, function(param) {
    var $location = param.$location, $single = param.$single;
    return $location === "left" && $single && (0,styled_components_browser_esm.css)(ShortcodeProducts_templateObject3(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
}));
function ShortcodeProducts(props) {
    var _shortcode = props.shortcode, location = _shortcode.location, products_products = _shortcode.products_products;
    if (products_products.length === 0) {
        return null;
    }
    var children = products_products.length === 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ShortcodeSingleProduct, {
        productPimCode: products_products[0].products_id.pim_code
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ShortcodeMultiProduct, {
        products: products_products
    });
    if (!children) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_components/* Theme */.Q, {
        theme: theme/* darkTheme */.$_,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShortcodeProductsContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            layout: true
        }, (0,transitions/* makeTransition */.Vr)({
            fade: true,
            from: location === "left" ? "left" : "right",
            speed: "slow"
        })), {
            $location: location,
            $single: products_products.length === 1,
            kind: "text",
            children: children
        }))
    });
}

;// CONCATENATED MODULE: ./src/components/player/overlays/ShortcodesOverlay/ShortcodeDiscriminator.tsx








var ShortcodeDiscriminator = function(param) {
    var shortcode = param.shortcode;
    switch(shortcode.type){
        case "link":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ShortcodeLink, {
                shortcode: shortcode
            });
        case "video":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ShortcodeVideo, {
                shortcode: shortcode
            });
        case "contact":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ShortcodeContact, {
                shortcode: shortcode
            });
        case "label":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ShortcodeLabel, {
                shortcode: shortcode
            });
        case "upcoming":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ShortcodeUpcomingVideo, {
                shortcode: shortcode
            });
        case "products":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ShortcodeProducts, {
                shortcode: shortcode
            });
        default:
            return null;
    }
};

// EXTERNAL MODULE: ./src/components/common/ModalControllerContext.tsx
var ModalControllerContext = __webpack_require__(19659);
// EXTERNAL MODULE: ./src/utils/WithSilentErrorBoundary.tsx
var WithSilentErrorBoundary = __webpack_require__(45402);
;// CONCATENATED MODULE: ./src/components/player/overlays/ShortcodesOverlay/index.tsx
















/**
 * Parse duration in hh:mm:ss and return duration in seconds
 * @param hhmmss
 */ var toSeconds = function(hhmmss) {
    var ref = (0,_sliced_to_array/* default */.Z)(hhmmss.padStart(8, "00:").split(":").map(function(v) {
        return parseInt(v);
    }), 3), hours = ref[0], minutes = ref[1], seconds = ref[2];
    return seconds + minutes * 60 + hours * 60 * 60;
};
var Shortcode = (0,WithSilentErrorBoundary/* withSilentErrorBoundary */.o)(function(param) {
    var shortcode = param.shortcode;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ShortcodeDiscriminator, {
        shortcode: shortcode
    });
});
var shortcodesLayerZIndex = player_common/* playerFadeZIndex */.PO - 2;
var ShortcodesOverlay = function(_param) {
    var time$ = _param.time$, shortcodes = _param.shortcodes, props = (0,_object_without_properties/* default */.Z)(_param, [
        "time$",
        "shortcodes"
    ]);
    var ref = (0,react.useReducer)(function(closedIds, shortcodeIdToClose) {
        return (0,rambda_esm.uniq)((0,_to_consumable_array/* default */.Z)(closedIds).concat([
            shortcodeIdToClose
        ]));
    }, []), closedShortcodes = ref[0], closeShortcode = ref[1];
    var translate = (0,useTranslateItem/* useTranslateItem */.L)();
    var mappedShortcodes = (0,react.useMemo)(function() {
        return shortcodes.filter(function(shortcode) {
            return !closedShortcodes.includes(shortcode.id);
        }).map(translate).map(function(shortcode) {
            var startTime = toSeconds(shortcode.display_time);
            var endTime = shortcode.hide_time ? toSeconds(shortcode.hide_time) : startTime + (durationByType[shortcode.type] || defaultDuration);
            return {
                startTime: startTime,
                endTime: endTime,
                shortcode: shortcode
            };
        });
    }, [
        translate,
        shortcodes,
        closedShortcodes
    ]);
    var currentShortcode = (0,useStream/* useStream */.Q)(function() {
        return time$.map(function(time) {
            var shortcodesInMoment = mappedShortcodes.filter(function(shortcode) {
                return shortcode.startTime <= time && time <= shortcode.endTime;
            });
            return (0,rambda_esm.head)((0,rambda_esm.sort)(function(x, y) {
                return x.startTime < y.startTime ? 1 : -1;
            }, shortcodesInMoment));
        });
    }, undefined, [
        time$,
        mappedShortcodes
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(player_common/* OverlayLayer */.s2, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        // place shortcodes under the share fade
        style: {
            zIndex: shortcodesLayerZIndex
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
            exitBeforeEnter: true,
            children: currentShortcode && /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalControllerContext/* ModalControllerContext.Provider */.L.Provider, {
                value: {
                    close: function(e) {
                        e === null || e === void 0 ? void 0 : e.preventDefault();
                        e === null || e === void 0 ? void 0 : e.stopPropagation();
                        closeShortcode(currentShortcode.shortcode.id);
                    }
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Shortcode, {
                    shortcode: currentShortcode.shortcode
                })
            }, currentShortcode.shortcode.id)
        })
    }));
};

// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 12 modules
var swiper_react = __webpack_require__(72873);
// EXTERNAL MODULE: ./src/modules/materials/hooks/useRelatedItemsListQuery.ts + 2 modules
var useRelatedItemsListQuery = __webpack_require__(99448);
;// CONCATENATED MODULE: ./src/components/player/overlays/RelatedVideosOverlay.tsx




function RelatedVideosOverlay_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: flex-end;\n  height: 100%;\n  padding: 0 36px 60px;\n  pointer-events: none;\n  ",
        " {\n    padding: 0 10px;\n    align-items: center;\n  }\n"
    ]);
    RelatedVideosOverlay_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function RelatedVideosOverlay_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  z-index: 1;\n"
    ]);
    RelatedVideosOverlay_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function RelatedVideosOverlay_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .swiper-slide {\n    width: 264px;\n    margin: 0 10px;\n    opacity: 1 !important;\n    pointer-events: all;\n    .nc-thumbnail__title {\n      ",
        "\n    }\n    ",
        " {\n      width: 110px;\n      margin: 0 2px;\n      .nc-thumbnail__title {\n        ",
        "\n      }\n      .nc-thumbnail__icon {\n        --base-unit: 100vw / 620;\n      }\n    }\n  }\n"
    ]);
    RelatedVideosOverlay_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function RelatedVideosOverlay_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin: 0 2px 10px;\n  ",
        " {\n    margin: 0 10px 14px;\n  }\n"
    ]);
    RelatedVideosOverlay_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function RelatedVideosOverlay_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-weight: 500;\n  font-size: 12px;\n\n  ",
        " {\n    font-size: 16px;\n  }\n"
    ]);
    RelatedVideosOverlay_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function RelatedVideosOverlay_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n  background: ",
        ";\n  pointer-events: all;\n  ",
        " {\n    pointer-events: none;\n    height: 460px;\n    top: auto;\n    bottom: -60px;\n    transform: rotate(-180deg);\n    background: linear-gradient(\n      186.88deg,\n      rgba(0, 0, 0, 0.4) 2.61%,\n      rgba(90, 90, 90, 0) 66.25%\n    );\n  }\n"
    ]);
    RelatedVideosOverlay_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  && {\n    margin-left: 10px;\n    width: 32px;\n    height: 32px;\n    pointer-events: all;\n    ",
        " {\n      width: 24px;\n      height: 24px;\n      .btn__content {\n        padding: 5px;\n      }\n      svg {\n        width: 12px;\n        height: 12px;\n      }\n    }\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}



















var mobileZIndex = player_common/* playerFadeZIndex */.PO + 1;
var desktopZIndex = player_common/* playerFadeZIndex */.PO - 1;
var maxTimeOffset = 15;
var Wrapper = (0,styled_components_browser_esm["default"])(motion/* motion.div */.E.div).withConfig({
    displayName: "RelatedVideosOverlay__Wrapper",
    componentId: "sc-14126bc2-0"
})(RelatedVideosOverlay_templateObject(), designs/* media.w.lessThan.desktop */.BC.w.lessThan.desktop);
var RelatedVideosOverlay_Content = styled_components_browser_esm["default"].div.withConfig({
    displayName: "RelatedVideosOverlay__Content",
    componentId: "sc-14126bc2-1"
})(RelatedVideosOverlay_templateObject1());
var VideoSwiper = (0,styled_components_browser_esm["default"])(swiper_react/* Swiper */.t).withConfig({
    displayName: "RelatedVideosOverlay__VideoSwiper",
    componentId: "sc-14126bc2-2"
})(RelatedVideosOverlay_templateObject2(), (0,common/* lineClamp */.Sf)(2), designs/* media.w.lessThan.desktop */.BC.w.lessThan.desktop, (0,common/* lineClamp */.Sf)(1));
var InfoBar = styled_components_browser_esm["default"].div.withConfig({
    displayName: "RelatedVideosOverlay__InfoBar",
    componentId: "sc-14126bc2-3"
})(RelatedVideosOverlay_templateObject3(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var Text = styled_components_browser_esm["default"].p.withConfig({
    displayName: "RelatedVideosOverlay__Text",
    componentId: "sc-14126bc2-4"
})(RelatedVideosOverlay_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.text.palette.primary;
}, designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var Fade = (0,styled_components_browser_esm["default"])(motion/* motion.div */.E.div).withConfig({
    displayName: "RelatedVideosOverlay__Fade",
    componentId: "sc-14126bc2-5"
})(RelatedVideosOverlay_templateObject5(), common/* layer */.EY, function(param) {
    var theme = param.theme;
    return (0,polished_esm/* transparentize */.DZ)(0.15, theme.palette.background);
}, designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var RelatedVideosOverlay_CloseButton = (0,styled_components_browser_esm["default"])(Button/* Button */.zx).withConfig({
    displayName: "RelatedVideosOverlay__CloseButton",
    componentId: "sc-14126bc2-6"
})(_templateObject6(), designs/* media.w.lessThan.desktop */.BC.w.lessThan.desktop);
var RelatedVideosOverlay = function(_param) {
    var time$ = _param.time$, video = _param.video, duration = _param.duration, onVisibilityChange = _param.onVisibilityChange, props = (0,_object_without_properties/* default */.Z)(_param, [
        "time$",
        "video",
        "duration",
        "onVisibilityChange"
    ]);
    var ref = (0,react.useState)(false), hasBeenClosed = ref[0], setHasBeenClosed = ref[1];
    var isDesktop = (0,useMediaQuery/* useMediaQuery */.a)(designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
    var _ = (0,lib.useTranslate)()._;
    var timeOffset = (0,react.useMemo)(function() {
        if (!duration) return 0;
        var offset = Math.round(duration * 0.2);
        return offset > maxTimeOffset ? maxTimeOffset : offset;
    }, [
        duration
    ]);
    var isInCorrectTimeRange = (0,useStream/* useStream */.Q)(function() {
        return time$.map(function(time) {
            return !!(duration && time >= duration - timeOffset);
        });
    }, false, [
        time$,
        duration
    ]);
    var ref1 = (0,useRelatedItemsListQuery/* useRelatedItemsListQuery */.s)(video, {
        enabled: !hasBeenClosed && isInCorrectTimeRange
    }), relatedVideos = ref1.data;
    var handleClose = (0,react.useCallback)(function() {
        return setHasBeenClosed(true);
    }, []);
    (0,react.useEffect)(function() {
        onVisibilityChange === null || onVisibilityChange === void 0 ? void 0 : onVisibilityChange(isInCorrectTimeRange);
    }, [
        isInCorrectTimeRange,
        onVisibilityChange
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(player_common/* OverlayLayer */.s2, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        style: {
            zIndex: isDesktop ? desktopZIndex : mobileZIndex
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_components/* Theme */.Q, {
            theme: theme/* darkTheme */.$_,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
                exitBeforeEnter: true,
                children: !!(!hasBeenClosed && relatedVideos && relatedVideos.length > 0 && isInCorrectTimeRange) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,transitions/* makeTransition */.Vr)({
                    from: "bottom",
                    to: "bottom",
                    fade: true
                })), {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Fade, (0,_object_spread/* default */.Z)({}, (0,transitions/* makeTransition */.Vr)({
                            fade: true
                        }))),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(RelatedVideosOverlay_Content, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(InfoBar, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                                            children: _("SEE ALSO")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(RelatedVideosOverlay_CloseButton, {
                                            compound: true,
                                            kind: "circled",
                                            icon: Close/* Close */.x,
                                            iconProps: {
                                                size: 14
                                            },
                                            onClick: handleClose
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoSwiper, {
                                    threshold: 15,
                                    slidesPerView: "auto",
                                    watchSlidesProgress: true,
                                    wrapperTag: "ul",
                                    children: relatedVideos.slice(0, isDesktop ? 4 : 3).map(function(video) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o, {
                                            tag: "li",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Thumbnail/* Thumbnail */.$, {
                                                item: video,
                                                showUserActions: isDesktop,
                                                showTags: false
                                            }, video.id)
                                        }, video.id);
                                    })
                                })
                            ]
                        })
                    ]
                }))
            })
        })
    }));
};

// EXTERNAL MODULE: ./node_modules/@summer/jst-react-icon/lib/index.js
var jst_react_icon_lib = __webpack_require__(55537);
;// CONCATENATED MODULE: ./src/components/icons/Expand.tsx




var Expand = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jst_react_icon_lib/* IconBox */.zb, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M6 59H58V7H34V11H54V55H10V35H6V59ZM10 13.8285V27H6V7H26V11H12.8284L29.4951 27.6667L26.6667 30.4951L10 13.8285Z"
        })
    }));
};

;// CONCATENATED MODULE: ./src/components/player/overlays/MiniplayerActionsOverlay.tsx

function MiniplayerActionsOverlay_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  pointer-events: all;\n  color: ",
        ";\n\n  position: absolute;\n  top: 12px;\n  right: 12px;\n  left: 12px;\n\n  opacity: 0;\n  transition: 0.15s;\n"
    ]);
    MiniplayerActionsOverlay_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function MiniplayerActionsOverlay_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        void 0
    ]);
    MiniplayerActionsOverlay_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}










var MiniplayerActionsOverlay_Container = (0,styled_components_browser_esm["default"])(motion/* motion.div */.E.div).withConfig({
    displayName: "MiniplayerActionsOverlay__Container",
    componentId: "sc-fee0da85-0"
})(MiniplayerActionsOverlay_templateObject(), function(param) {
    var theme = param.theme;
    return theme.text.palette.primary;
});
// eslint-disable-next-line react/display-name
var MiniplayerActionsOverlay = /*#__PURE__*/ (0,react.memo)(function(param) {
    var onReturn = param.onReturn, onClose = param.onClose;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_components/* Theme */.Q, {
        theme: theme/* darkTheme */.$_,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(_StyledOverlayLayer, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(MiniplayerActionsOverlay_Container, {
                className: "player__miniplayer-actions-overlay",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.zx, {
                        kind: "circled",
                        size: "small",
                        icon: Expand,
                        onClick: onReturn
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.zx, {
                        kind: "circled",
                        size: "small",
                        icon: Close/* Close */.x,
                        onClick: onClose
                    })
                ]
            })
        })
    });
});
var _StyledOverlayLayer = (0,styled_components_browser_esm["default"])(player_common/* OverlayLayer */.s2).withConfig({
    displayName: "MiniplayerActionsOverlay___StyledOverlayLayer",
    componentId: "sc-fee0da85-1"
})(MiniplayerActionsOverlay_templateObject1());

;// CONCATENATED MODULE: ./src/components/icons/Talks.tsx




var Talks = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jst_react_icon_lib/* IconBox */.zb, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M3.82301 3.82398C3.95571 3.69128 4.1357 3.61672 4.32337 3.61672H44.5791C44.7668 3.61672 44.9467 3.69128 45.0795 3.82398C45.2122 3.95668 45.2867 4.13667 45.2867 4.32435V16.8704C45.2865 16.8816 45.2864 16.8927 45.2864 16.904C45.2864 16.9152 45.2865 16.9263 45.2867 16.9375V32.0002C45.2867 32.1878 45.2122 32.3678 45.0795 32.5005C44.9468 32.6332 44.7668 32.7078 44.5791 32.7078H16.9367C16.9255 32.7076 16.9143 32.7075 16.903 32.7075C16.8917 32.7075 16.8804 32.7076 16.8692 32.7078H13.6166L3.61575 40.7927V4.32435C3.61575 4.13667 3.6903 3.95669 3.82301 3.82398ZM15.0946 36.3245H14.8957L-0.000976562 48.3674V4.32435C-0.000976562 3.17746 0.454624 2.07754 1.2656 1.26657C2.07657 0.455601 3.17648 0 4.32337 0H44.5791C45.726 0 46.8259 0.455599 47.6369 1.26657C48.4478 2.07755 48.9034 3.17746 48.9034 4.32435V15.0956H59.6747C60.8216 15.0956 61.9215 15.5512 62.7324 16.3622C63.5434 17.1731 63.999 18.273 63.999 19.4199V63.463L49.1024 51.4201H19.419C18.2721 51.4201 17.1722 50.9645 16.3612 50.1535C15.5502 49.3425 15.0946 48.2426 15.0946 47.0957V36.3245ZM18.7113 36.3245V47.0957C18.7113 47.2834 18.7859 47.4634 18.9186 47.5961C19.0513 47.7288 19.2313 47.8034 19.419 47.8034H50.3815L60.3823 55.8883V19.4199C60.3823 19.2323 60.3077 19.0523 60.175 18.9196C60.0423 18.7869 59.8623 18.7123 59.6747 18.7123H48.9034V32.0002C48.9034 33.147 48.4478 34.247 47.6369 35.0579C46.8259 35.8689 45.726 36.3245 44.5791 36.3245H18.7113Z"
        })
    }));
};

// EXTERNAL MODULE: ./node_modules/react-use/esm/useToggle.js
var useToggle = __webpack_require__(89211);
;// CONCATENATED MODULE: ./src/components/player/overlays/ContactButtonOverlay.tsx


function ContactButtonOverlay_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  bottom: 50px;\n  right: 16px;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 8px;\n\n  ",
        " {\n    right: 40px;\n  }\n"
    ]);
    ContactButtonOverlay_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ContactButtonOverlay_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  pointer-events: all;\n\n  ",
        " {\n    padding: 5px;\n  }\n"
    ]);
    ContactButtonOverlay_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ContactButtonOverlay_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 185px;\n  background-color: rgba(0, 0, 0, 0.4);\n  display: flex;\n  flex-direction: column;\n  padding: 21px 16px 16px 16px;\n  gap: 16px;\n  color: ",
        ";\n"
    ]);
    ContactButtonOverlay_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ContactButtonOverlay_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  pointer-events: all;\n  min-width: 100% !important;\n  border-color: ",
        " !important;\n"
    ]);
    ContactButtonOverlay_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function ContactButtonOverlay_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 14px;\n  line-height: 16px;\n  text-transform: uppercase;\n  font-weight: 500;\n\n  ",
        " {\n    text-align: right;\n  }\n"
    ]);
    ContactButtonOverlay_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}












var ContactButtonOverlay_Wrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ContactButtonOverlay__Wrapper",
    componentId: "sc-b5e0193-0"
})(ContactButtonOverlay_templateObject(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var ToggleContactInfoButton = (0,styled_components_browser_esm["default"])(Button/* Button */.zx).withConfig({
    displayName: "ContactButtonOverlay__ToggleContactInfoButton",
    componentId: "sc-b5e0193-1"
})(ContactButtonOverlay_templateObject1(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var StyledContactInfoWrapper = (0,styled_components_browser_esm["default"])(motion/* motion.div */.E.div).withConfig({
    displayName: "ContactButtonOverlay__StyledContactInfoWrapper",
    componentId: "sc-b5e0193-2"
})(ContactButtonOverlay_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.text.palette.secondary;
});
var ContactButton = (0,styled_components_browser_esm["default"])(Button/* Button */.zx).withConfig({
    displayName: "ContactButtonOverlay__ContactButton",
    componentId: "sc-b5e0193-3"
})(ContactButtonOverlay_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.palette.accent;
});
var CallToActionText = styled_components_browser_esm["default"].span.withConfig({
    displayName: "ContactButtonOverlay__CallToActionText",
    componentId: "sc-b5e0193-4"
})(ContactButtonOverlay_templateObject4(), theme/* dirRTL */.gX);
var ContactButtonOverlay = function() {
    var ref = (0,_sliced_to_array/* default */.Z)((0,useToggle/* default */.Z)(false), 2), contactInfoVisible = ref[0], toggleContactInfoVisible = ref[1];
    var _ = (0,lib.useTranslate)()._;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(player_common/* OverlayLayer */.s2, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContactButtonOverlay_Wrapper, {
            children: [
                contactInfoVisible && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledContactInfoWrapper, {
                    animate: {
                        opacity: 1
                    },
                    initial: {
                        opacity: 0
                    },
                    exit: {
                        opacity: 0
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CallToActionText, {
                            children: _("Contact our Neauvia expert")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DispatchOnClick/* DispatchOnClick */.Q, {
                            type: "modalOpen",
                            payload: {
                                kind: "contact"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactButton, {
                                size: "small",
                                variant: "secondary",
                                onClick: toggleContactInfoVisible,
                                children: _("contact me")
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ToggleContactInfoButton, {
                    forwardedAs: "a",
                    kind: "circled",
                    icon: contactInfoVisible ? Close/* Close */.x : Talks,
                    iconProps: {
                        width: 20,
                        height: 20
                    },
                    onClick: toggleContactInfoVisible
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./src/components/ScrollableContent.tsx
var ScrollableContent = __webpack_require__(53402);
// EXTERNAL MODULE: ./node_modules/react-use/esm/useIsomorphicLayoutEffect.js
var useIsomorphicLayoutEffect = __webpack_require__(11042);
// EXTERNAL MODULE: ./src/utils/storage.ts
var storage = __webpack_require__(25849);
;// CONCATENATED MODULE: ./src/hooks/useSynchronizedSessionStorage.ts



var useSynchronizedSessionStorage = function(key, initialValue) {
    var ref;
    var ref1 = (0,react.useState)(function() {
        return (ref = storage/* sessionStorage.getItem */.y.getItem(key)) !== null && ref !== void 0 ? ref : initialValue;
    }), state = ref1[0], setState = ref1[1];
    var ref2;
    (0,useIsomorphicLayoutEffect/* default */.Z)(function() {
        return setState((ref2 = storage/* sessionStorage.getItem */.y.getItem(key)) !== null && ref2 !== void 0 ? ref2 : initialValue);
    }, [
        key
    ]);
    var set = (0,react.useCallback)(function(newState) {
        setState(newState);
        storage/* sessionStorage.setItem */.y.setItem(key, newState);
        window.dispatchEvent(new CustomEvent("sessionStorageCustom"));
    }, [
        key
    ]);
    var remove = (0,react.useCallback)(function() {
        setState(undefined);
        storage/* sessionStorage.removeItem */.y.removeItem(key);
        window.dispatchEvent(new CustomEvent("sessionStorageCustom"));
    }, [
        key
    ]);
    (0,react.useEffect)(function() {
        var updateValue = function() {
            var ref;
            setState((ref = storage/* sessionStorage.getItem */.y.getItem(key)) !== null && ref !== void 0 ? ref : initialValue);
        };
        window.addEventListener("sessionStorageCustom", updateValue);
        return function() {
            window.removeEventListener("sessionStorageCustom", updateValue);
        };
    }, [
        initialValue,
        key
    ]);
    return [
        state,
        set,
        remove
    ];
};

;// CONCATENATED MODULE: ./src/hooks/useUserMdrDisclaimer.ts



var useUserMdrDisclaimer = function() {
    var ref = (0,_sliced_to_array/* default */.Z)(useSynchronizedSessionStorage("nc_mdr-disclaimer"), 2), confirmed = ref[0], setConfirmed = ref[1];
    var onConfirm = (0,react.useCallback)(function() {
        setConfirmed(true);
    }, [
        setConfirmed
    ]);
    return {
        confirmed: confirmed,
        onConfirm: onConfirm
    };
};

;// CONCATENATED MODULE: ./src/components/player/overlays/MdrDisclaimerOverlay.tsx



function MdrDisclaimerOverlay_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n\n  .simplebar-content-wrapper {\n    display: flex;\n    height: 100% !important;\n    & > div {\n      margin: auto;\n    }\n  }\n\n  z-index: ",
        ";\n  width: 100%;\n"
    ]);
    MdrDisclaimerOverlay_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function MdrDisclaimerOverlay_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 500;\n  font-size: 14px;\n  letter-spacing: 0.02em;\n"
    ]);
    MdrDisclaimerOverlay_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function MdrDisclaimerOverlay_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  font-size: 300;\n  font-size: 11px;\n  line-height: 18px;\n\n  ",
        " {\n    font-size: 16px;\n    line-height: 24px;\n  }\n"
    ]);
    MdrDisclaimerOverlay_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function MdrDisclaimerOverlay_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  z-index: ",
        ";\n  ",
        " {\n    direction: rtl;\n  }\n"
    ]);
    MdrDisclaimerOverlay_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function MdrDisclaimerOverlay_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: auto;\n\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  padding: 24px 32px 32px;\n\n  max-width: 570px;\n  color: ",
        ";\n"
    ]);
    MdrDisclaimerOverlay_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}















var MdrDisclaimerOverlay_Container = (0,styled_components_browser_esm["default"])(ScrollableContent/* ShadowedScrollableContent */.w).withConfig({
    displayName: "MdrDisclaimerOverlay__Container",
    componentId: "sc-e3e9245f-0"
})(MdrDisclaimerOverlay_templateObject(), player_common/* playerFadeZIndex */.PO + 1);
var Heading = styled_components_browser_esm["default"].div.withConfig({
    displayName: "MdrDisclaimerOverlay__Heading",
    componentId: "sc-e3e9245f-1"
})(MdrDisclaimerOverlay_templateObject1());
var Description = (0,styled_components_browser_esm["default"])(motion/* motion.div */.E.div).withConfig({
    displayName: "MdrDisclaimerOverlay__Description",
    componentId: "sc-e3e9245f-2"
})(MdrDisclaimerOverlay_templateObject2(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var StyledOverlayLayer = (0,styled_components_browser_esm["default"])(player_common/* OverlayLayer */.s2).withConfig({
    displayName: "MdrDisclaimerOverlay__StyledOverlayLayer",
    componentId: "sc-e3e9245f-3"
})(MdrDisclaimerOverlay_templateObject3(), player_common/* playerOverlayAboveControlsZIndex */._R, theme/* dirRTL */.gX);
var ContentContainer = (0,styled_components_browser_esm["default"])(motion/* motion.div */.E.div).withConfig({
    displayName: "MdrDisclaimerOverlay__ContentContainer",
    componentId: "sc-e3e9245f-4"
})(MdrDisclaimerOverlay_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.text.palette.primary;
});
var MdrDisclaimerOverlay = function(param) {
    var video = param.video, onUnmute = param.onUnmute, onPlay = param.onPlay, onPause = param.onPause;
    var _ = (0,lib.useTranslate)()._;
    var mdrDisclaimer = useUserMdrDisclaimer();
    var visible = !mdrDisclaimer.confirmed && video.disclaimer;
    var onConfirm = function() {
        mdrDisclaimer.onConfirm();
        onUnmute();
        onPlay();
    };
    (0,react.useEffect)(function() {
        if (visible) {
            onPause();
        }
    }, [
        onPause,
        visible
    ]);
    if (!visible) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledOverlayLayer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,transitions/* makeTransition */.Vr)({
        fade: true
    })), {
        as: motion/* motion.div */.E.div,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled_components/* Theme */.Q, {
            theme: theme/* darkTheme */.$_,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(HealthcareLegalConsentOverlay/* Fade */.p, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(MdrDisclaimerOverlay_Container, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,transitions/* makeTransition */.Vr)({
                        from: "top",
                        to: "bottom"
                    })), {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading, {
                                children: _("video.disclaimer.title")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Description, {
                                style: {
                                    direction: "ltr"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Markdown/* Markdown */.U, {
                                    children: _("video.disclaimer.text")
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* FullWidthButton */.Ow, {
                                onClick: onConfirm,
                                children: _("CONFIRM AND WATCH")
                            })
                        ]
                    }))
                })
            ]
        })
    }));
};

;// CONCATENATED MODULE: ./src/components/player/OverlayController.tsx





















var OverlayController = /*#__PURE__*/ (0,react.memo)(function OverlayController(param) {
    var controls = param.controls, video = param.video, ready = param.ready, playing = param.playing, muted = param.muted, unmutedOnce = param.unmutedOnce, fullscreen = param.fullscreen, miniplayer = param.miniplayer, time$ = param.time$, duration = param.duration, onPlay = param.onPlay, onPause = param.onPause, onUnmute = param.onUnmute, onOpenMiniplayer = param.onOpenMiniplayer;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16;
    var ref17 = (0,useUserHealthcareLegalConsent/* useUserHealthcareLegalConsent */.P)(), healthcareConsent = ref17.userConsentValue;
    var isLocked = !(0,permissions/* canUserAccessItem */.k)(video);
    var canAccess = !isLocked;
    var isMobile = (0,useMediaQuery/* useMediaQuery */.a)(designs/* media.w.lessThan.desktop */.BC.w.lessThan.desktop);
    var ref18 = (0,react.useState)(false), showShareOverlay = ref18[0], setShowShareOverlay = ref18[1];
    var ref19 = (0,react.useState)(false), relatedVideosVisible = ref19[0], setRelatedVideosVisible = ref19[1];
    var showMuteOverlay = !relatedVideosVisible && !(isMobile && miniplayer) && playing && muted && !unmutedOnce && healthcareConsent && ready && canAccess;
    var ref20;
    var showUserActionsOverlay = (ref20 = controls === null || controls === void 0 ? void 0 : (ref = controls.userActions) === null || ref === void 0 ? void 0 : ref.enabled) !== null && ref20 !== void 0 ? ref20 : true;
    var ref21;
    var allowMiniplayer = ((ref21 = controls === null || controls === void 0 ? void 0 : (ref1 = controls.userActions) === null || ref1 === void 0 ? void 0 : ref1.miniplayer) !== null && ref21 !== void 0 ? ref21 : true) && !fullscreen;
    var ref22;
    var allowShare = (ref22 = controls === null || controls === void 0 ? void 0 : (ref2 = controls.userActions) === null || ref2 === void 0 ? void 0 : ref2.share) !== null && ref22 !== void 0 ? ref22 : true;
    var ref23;
    var showMiniplayerActionsOverlay = ((ref23 = controls === null || controls === void 0 ? void 0 : (ref3 = controls.miniplayerActions) === null || ref3 === void 0 ? void 0 : ref3.enabled) !== null && ref23 !== void 0 ? ref23 : false) && !isMobile && !fullscreen;
    var showTitleOverlay = (controls === null || controls === void 0 ? void 0 : (ref4 = controls.title) === null || ref4 === void 0 ? void 0 : ref4.enabled) && !playing;
    var showContactButtonOverlay = !miniplayer && !isLocked;
    var ref24;
    var showRelatedVideosOverlay = ((ref24 = controls === null || controls === void 0 ? void 0 : (ref5 = controls.relatedVideos) === null || ref5 === void 0 ? void 0 : ref5.enabled) !== null && ref24 !== void 0 ? ref24 : true) && ((ref6 = video.source) === null || ref6 === void 0 ? void 0 : ref6.format) === models/* VideoFormat.Wistia */.Z.Wistia && ready && canAccess;
    var ref25;
    var showShortcodesOverlay = ((ref25 = controls === null || controls === void 0 ? void 0 : (ref7 = controls.shortcodes) === null || ref7 === void 0 ? void 0 : ref7.enabled) !== null && ref25 !== void 0 ? ref25 : true) && ((ref8 = video.source) === null || ref8 === void 0 ? void 0 : ref8.format) === models/* VideoFormat.Wistia */.Z.Wistia && video.shortcodes != null && ready && canAccess;
    var showVideoSummary = !showMuteOverlay && !showShareOverlay && (controls === null || controls === void 0 ? void 0 : (ref9 = controls.summary) === null || ref9 === void 0 ? void 0 : ref9.enabled) && !fullscreen && healthcareConsent && ready && canAccess;
    var ref26;
    var showHealthcareConsentOverlay = ((ref26 = controls === null || controls === void 0 ? void 0 : (ref10 = controls.healthcareConsent) === null || ref10 === void 0 ? void 0 : ref10.enabled) !== null && ref26 !== void 0 ? ref26 : true) && canAccess;
    var ref27;
    var showMdrDisclaimerOverlay = ((ref27 = controls === null || controls === void 0 ? void 0 : (ref11 = controls.mdrDisclaimer) === null || ref11 === void 0 ? void 0 : ref11.enabled) !== null && ref27 !== void 0 ? ref27 : true) && canAccess;
    (0,react.useEffect)(function() {
        setShowShareOverlay(false);
    }, [
        video
    ]);
    var openShareOverlay = (0,react.useCallback)(function() {
        setShowShareOverlay(true);
    }, [
        setShowShareOverlay
    ]);
    var closeShareOverlay = (0,react.useCallback)(function() {
        setShowShareOverlay(false);
    }, [
        setShowShareOverlay
    ]);
    var ref28, ref29;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_components/* Theme */.Q, {
        theme: theme/* darkTheme */.$_,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(AnimatePresence/* AnimatePresence */.M, {
            children: [
                showVideoSummary && /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoSummaryOverlay, {
                    video: video
                }, "VideoSummaryOverlay"),
                showMuteOverlay && /*#__PURE__*/ (0,jsx_runtime.jsx)(UnmuteOverlay, {
                    onUnmute: onUnmute
                }, "UnmuteOverlay"),
                showUserActionsOverlay && /*#__PURE__*/ (0,jsx_runtime.jsx)(UserActionsOverlay, {
                    video: video,
                    allowMiniplayer: allowMiniplayer,
                    allowShare: allowShare,
                    onShareOpen: openShareOverlay,
                    onOpenMiniplayer: onOpenMiniplayer
                }, "UserActionsOverlay"),
                showTitleOverlay && /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleOverlay, {
                    video: video,
                    backHref: controls === null || controls === void 0 ? void 0 : (ref12 = controls.title) === null || ref12 === void 0 ? void 0 : ref12.backHref
                }, "TitleOverlay"),
                showContactButtonOverlay && /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactButtonOverlay, {}, "ContactButtonOverlay"),
                showRelatedVideosOverlay && /*#__PURE__*/ (0,jsx_runtime.jsx)(RelatedVideosOverlay, {
                    time$: time$,
                    video: video,
                    duration: duration,
                    onVisibilityChange: setRelatedVideosVisible
                }, "RelatedVideosOverlay"),
                showShortcodesOverlay && /*#__PURE__*/ (0,jsx_runtime.jsx)(ShortcodesOverlay, {
                    time$: time$,
                    shortcodes: video.shortcodes,
                    onClick: onPause
                }, "ShortcodesOverlay"),
                showShareOverlay && /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareOverlay, {
                    titles: true,
                    close: closeShareOverlay
                }),
                showHealthcareConsentOverlay && /*#__PURE__*/ (0,jsx_runtime.jsx)(HealthcareLegalConsentOverlay/* HealthcareLegalConsentOverlay */.x, {
                    onPlay: onPlay,
                    onUnmute: onUnmute,
                    backgroundOnly: controls === null || controls === void 0 ? void 0 : (ref13 = controls.healthcareConsent) === null || ref13 === void 0 ? void 0 : ref13.backgroundOnly,
                    onBackgroundClick: controls === null || controls === void 0 ? void 0 : (ref14 = controls.healthcareConsent) === null || ref14 === void 0 ? void 0 : ref14.onBackgroundClick
                }, "HealthcareLegalConsentOverlay"),
                showMdrDisclaimerOverlay && /*#__PURE__*/ (0,jsx_runtime.jsx)(MdrDisclaimerOverlay, {
                    video: video,
                    onUnmute: onUnmute,
                    onPlay: onPlay,
                    onPause: onPause
                }, "MdrDisclaimerOverlay"),
                showMiniplayerActionsOverlay && /*#__PURE__*/ (0,jsx_runtime.jsx)(MiniplayerActionsOverlay, {
                    onReturn: (ref28 = controls === null || controls === void 0 ? void 0 : (ref15 = controls.miniplayerActions) === null || ref15 === void 0 ? void 0 : ref15.onReturn) !== null && ref28 !== void 0 ? ref28 : function() {
                        return null;
                    },
                    onClose: (ref29 = controls === null || controls === void 0 ? void 0 : (ref16 = controls.miniplayerActions) === null || ref16 === void 0 ? void 0 : ref16.onClose) !== null && ref29 !== void 0 ? ref29 : function() {
                        return null;
                    }
                })
            ]
        })
    });
});

// EXTERNAL MODULE: ./node_modules/@hitorisensei/kefir-atomic/dist/kefir.esm.js
var kefir_esm = __webpack_require__(61031);
// EXTERNAL MODULE: ./node_modules/iso8601-duration/lib/index.js
var iso8601_duration_lib = __webpack_require__(42604);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./src/components/player/playerStrategy/playerStrategyProvider.ts


var WistiaPlayerStrategy = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 1768).then(__webpack_require__.bind(__webpack_require__, 41768));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(41768)
            ];
        }
    }
});
var ReactPlayerStrategy = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5629), __webpack_require__.e(1955)]).then(__webpack_require__.bind(__webpack_require__, 11955));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(11955)
            ];
        }
    }
});
var SourcelessPlayerStrategy = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7305).then(__webpack_require__.bind(__webpack_require__, 17305));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(17305)
            ];
        }
    }
});
var playerStrategyProvider = function(source) {
    if (source == null) {
        return SourcelessPlayerStrategy;
    }
    if (source.format === models/* VideoFormat.LiveHLS */.Z.LiveHLS) {
        return ReactPlayerStrategy;
    }
    return WistiaPlayerStrategy;
};

// EXTERNAL MODULE: ./src/components/player/playerId.ts
var playerId = __webpack_require__(19295);
// EXTERNAL MODULE: ./node_modules/memoizee/index.js
var memoizee = __webpack_require__(34156);
var memoizee_default = /*#__PURE__*/__webpack_require__.n(memoizee);
// EXTERNAL MODULE: ./src/store/actions.ts + 1 modules
var actions = __webpack_require__(88776);
// EXTERNAL MODULE: ./src/store/miniplayer/selectors.ts
var selectors = __webpack_require__(95406);
// EXTERNAL MODULE: ./src/components/icons/Miniplayer.tsx
var Miniplayer = __webpack_require__(37971);
;// CONCATENATED MODULE: ./src/components/player/overlays/MiniplayerInfoOverlay.tsx




function MiniplayerInfoOverlay_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  z-index: 100;\n"
    ]);
    MiniplayerInfoOverlay_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function MiniplayerInfoOverlay_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  color: ",
        ";\n  padding: 20px;\n\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  background: #000;\n"
    ]);
    MiniplayerInfoOverlay_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function MiniplayerInfoOverlay_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n  text-transform: uppercase;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 16px;\n  margin-top: 20px;\n"
    ]);
    MiniplayerInfoOverlay_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}










var MiniplayerInfoOverlay_StyledOverlayLayer = (0,styled_components_browser_esm["default"])(player_common/* OverlayLayer */.s2).withConfig({
    displayName: "MiniplayerInfoOverlay__StyledOverlayLayer",
    componentId: "sc-d3321a80-0"
})(MiniplayerInfoOverlay_templateObject());
var MiniplayerInfoOverlay_Container = (0,styled_components_browser_esm["default"])(motion/* motion.div */.E.div).withConfig({
    displayName: "MiniplayerInfoOverlay__Container",
    componentId: "sc-d3321a80-1"
})(MiniplayerInfoOverlay_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.text.palette.primary;
});
var MiniplayerInfoOverlay_Text = styled_components_browser_esm["default"].p.withConfig({
    displayName: "MiniplayerInfoOverlay__Text",
    componentId: "sc-d3321a80-2"
})(MiniplayerInfoOverlay_templateObject2());
var MiniplayerInfoOverlay_transition = (0,transitions/* makeTransition */.Vr)({
    fade: true
});
// eslint-disable-next-line react/display-name
var MiniplayerInfoOverlay = /*#__PURE__*/ (0,react.memo)(function(_param) {
    var props = (0,_extends/* default */.Z)({}, _param);
    var _ = (0,lib.useTranslate)()._;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MiniplayerInfoOverlay_StyledOverlayLayer, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_components/* Theme */.Q, {
            theme: theme/* darkTheme */.$_,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(MiniplayerInfoOverlay_Container, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                className: "player__pip-overlay"
            }, props, MiniplayerInfoOverlay_transition), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Miniplayer/* Miniplayer */.M, {
                        size: 37
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MiniplayerInfoOverlay_Text, {
                        children: _("This video is playing in the miniplayer")
                    })
                ]
            }))
        })
    });
});

// EXTERNAL MODULE: ./node_modules/lodash/noop.js
var noop = __webpack_require__(50308);
var noop_default = /*#__PURE__*/__webpack_require__.n(noop);
// EXTERNAL MODULE: ./node_modules/reselect/es/index.js + 1 modules
var reselect_es = __webpack_require__(68697);
;// CONCATENATED MODULE: ./src/store/app/selectors.ts

var selectAppState = function(store) {
    return store.app;
};
var selectActivePlayerId = (0,reselect_es/* createSelector */.P1)(selectAppState, function(state) {
    return state.activePlayerId;
});

;// CONCATENATED MODULE: ./src/components/player/playerSettings.ts

var PlayerSettings;
(function(PlayerSettings) {
    PlayerSettings["Volume"] = "neauvia-player-volume";
})(PlayerSettings || (PlayerSettings = {}));
var getSavedPlayerSettings = function(key) {
    var ref;
    return (ref = storage/* localStorage.getItem */.X.getItem(key)) !== null && ref !== void 0 ? ref : null;
};
var savePlayerSettings = function(key, value) {
    return storage/* localStorage.setItem */.X.setItem(key, value);
};

// EXTERNAL MODULE: ./node_modules/react-uid/dist/es2015/hooks.js + 2 modules
var hooks = __webpack_require__(34699);
;// CONCATENATED MODULE: ./src/components/player/index.tsx








function player_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          position: absolute;\n          top: 0;\n          left: 0;\n          width: 100%;\n          height: 100%;\n        "
    ]);
    player_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function player_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  direction: ltr !important;\n\n  display: inline-block;\n  width: 100%;\n  box-sizing: border-box;\n  vertical-align: top;\n  position: relative;\n  z-index: 3;\n\n  ",
        "\n\n  &:hover .np-overlay__video-summary {\n    transform: translateX(0);\n    opacity: 1;\n  }\n\n  &:hover .player__miniplayer-actions-overlay {\n    opacity: 1;\n  }\n"
    ]);
    player_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function player_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 0;\n  height: 0;\n  position: absolute;\n  top: calc(-1 * var(--header-static-height));\n"
    ]);
    player_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function player_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    player_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


















var iso8601ToSeconds = memoizee_default()(function(a) {
    return (0,iso8601_duration_lib/* toSeconds */.my)((0,iso8601_duration_lib/* parse */.Qc)(a));
});
var player_Container = styled_components_browser_esm["default"].div.withConfig({
    displayName: "player__Container",
    componentId: "sc-567d0ac2-0"
})(player_templateObject1(), function(param) {
    var $ar = param.$ar;
    return $ar != null ? (0,common.ar)($ar) : (0,styled_components_browser_esm.css)(player_templateObject());
});
var ScrollHandle = styled_components_browser_esm["default"].div.withConfig({
    displayName: "player__ScrollHandle",
    componentId: "sc-567d0ac2-1"
})(player_templateObject2());
var NeauviaPlayerComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(NeauviaPlayerComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(NeauviaPlayerComponent);
    function NeauviaPlayerComponent(props) {
        (0,_class_call_check/* default */.Z)(this, NeauviaPlayerComponent);
        var _this;
        _this = _super.call(this, props);
        _this.openInMiniplayer = function(state) {
            var ref;
            if (_this.props.miniplayer || _this.props.isInMiniplayer) {
                return;
            }
            _this.props.openMiniplayer((0,_object_spread/* default */.Z)({
                playerId: _this.props.playerId,
                video: _this.props.video,
                playing: _this.state.playing,
                playFrom: (ref = _this.playerApi) === null || ref === void 0 ? void 0 : ref.getCurrentTime(),
                muted: _this.state.muted,
                volume: _this.state.volume
            }, state));
            _this.props.attachMiniplayer(_this.onReturnFromMiniplayer);
        };
        _this.scrollHandleRef = /*#__PURE__*/ (0,react.createRef)();
        _this.time$ = (0,kefir_esm/* fromPoll */.CR)(1000, function() {
            return _this.state.playing;
        }).skipDuplicates().flatMapLatest(function(isPlaying) {
            if (isPlaying != null) {
                var ref;
                var getTime = function() {
                    var ref1;
                    return (ref = (ref1 = _this.playerApi) === null || ref1 === void 0 ? void 0 : ref1.getRealTime()) !== null && ref !== void 0 ? ref : 0;
                };
                var currentTime = (0,kefir_esm/* constant */.a9)(getTime());
                return isPlaying ? currentTime.concat((0,kefir_esm/* fromPoll */.CR)(300, getTime)) : currentTime;
            } else {
                return (0,kefir_esm/* never */.Fi)();
            }
        });
        // -- HANDLERS START
        _this.onInnerRef = function(a) {
            return _this.playerApi = a;
        };
        _this.onReady = function() {
            var _props, ref;
            _this.setState({
                ready: true
            });
            (ref = (_props = _this.props).onReady) === null || ref === void 0 ? void 0 : ref.call(_props, _this.stateSnapshot);
        };
        _this.onPlay = function() {
            var _props, ref;
            if (_this.state.disabled) {
                return;
            }
            _this.setState({
                ready: true,
                playing: true,
                playedOnce: true
            });
            NeauviaPlayerComponent.recentMutedOption = _this.state.muted;
            NeauviaPlayerComponent.recentVolumeOption = _this.state.volume;
            if (!_this.state.muted) {
                _this.props.setAsActivePlayer();
                if (!_this.props.miniplayer) {
                    _this.props.resetMiniplayer();
                }
            }
            (ref = (_props = _this.props).onPlay) === null || ref === void 0 ? void 0 : ref.call(_props);
        };
        _this.onSeek = function(time) {
            var _props, ref;
            if (_this.state.disabled) {
                return;
            }
            (ref = (_props = _this.props).onSeek) === null || ref === void 0 ? void 0 : ref.call(_props, time);
        };
        _this.onPause = function() {
            var _props, ref;
            if (_this.state.disabled) {
                return;
            }
            _this.setState({
                playing: false
            });
            (ref = (_props = _this.props).onPause) === null || ref === void 0 ? void 0 : ref.call(_props);
        };
        _this.onEnded = function() {
            var _props, ref;
            if (_this.state.disabled) {
                return;
            }
            _this.setState({
                playing: false
            });
            (ref = (_props = _this.props).onEnded) === null || ref === void 0 ? void 0 : ref.call(_props);
        };
        _this.onVolumeChange = function(volume) {
            var _props, ref;
            if (_this.state.disabled) {
                return;
            }
            _this.setState({
                volume: volume
            });
            NeauviaPlayerComponent.recentVolumeOption = volume;
            savePlayerSettings(PlayerSettings.Volume, volume);
            (ref = (_props = _this.props).onVolumeChange) === null || ref === void 0 ? void 0 : ref.call(_props, volume);
        };
        _this.onMute = function(reset) {
            var _props, ref;
            if (_this.state.disabled) {
                return;
            }
            if (reset) {
                _this.setState({
                    muted: true,
                    unmutedOnce: false
                });
            } else {
                _this.setState({
                    muted: true
                });
            }
            NeauviaPlayerComponent.recentMutedOption = true;
            (ref = (_props = _this.props).onMute) === null || ref === void 0 ? void 0 : ref.call(_props);
        };
        _this.onUnmute = function() {
            var _props, ref;
            if (_this.state.disabled) {
                return;
            }
            _this.setState({
                muted: false,
                unmutedOnce: true
            });
            NeauviaPlayerComponent.recentMutedOption = false;
            if (_this.state.playing) {
                _this.props.setAsActivePlayer();
                if (!_this.props.miniplayer) {
                    _this.props.resetMiniplayer();
                }
            }
            (ref = (_props = _this.props).onUnmute) === null || ref === void 0 ? void 0 : ref.call(_props);
        };
        _this.onEnterFullscreen = function() {
            var _props, ref;
            if (_this.state.disabled) {
                return;
            }
            _this.setState({
                fullscreen: true
            });
            (ref = (_props = _this.props).onEnterFullscreen) === null || ref === void 0 ? void 0 : ref.call(_props);
        };
        _this.onLeaveFullscreen = function() {
            var _props, ref;
            if (_this.state.disabled) {
                return;
            }
            _this.setState({
                fullscreen: false
            });
            (ref = (_props = _this.props).onLeaveFullscreen) === null || ref === void 0 ? void 0 : ref.call(_props);
        };
        _this.onReturnFromMiniplayer = function(state) {
            var _playing, _playing1, _muted, ref, _volume, _playFrom;
            _this.setState(function(prevState) {
                return {
                    playing: (_playing = state.playing) !== null && _playing !== void 0 ? _playing : prevState.playing,
                    playedOnce: (_playing1 = state.playing) !== null && _playing1 !== void 0 ? _playing1 : prevState.playedOnce,
                    muted: (_muted = state.muted) !== null && _muted !== void 0 ? _muted : prevState.muted,
                    unmutedOnce: (ref = !state.muted) !== null && ref !== void 0 ? ref : prevState.unmutedOnce,
                    volume: (_volume = state.volume) !== null && _volume !== void 0 ? _volume : prevState.volume,
                    playFrom: (_playFrom = state.playFrom) !== null && _playFrom !== void 0 ? _playFrom : prevState.playFrom
                };
            });
            if (_this.props.playerId.includes(playerId/* PlayerId.TVLike */.z.TVLike)) {
                window.scrollTo({
                    top: 0,
                    behavior: "smooth"
                });
            } else {
                var ref1;
                (ref1 = _this.scrollHandleRef.current) === null || ref1 === void 0 ? void 0 : ref1.scrollIntoView({
                    behavior: "smooth",
                    block: "start"
                });
            }
        };
        var savedVolume = getSavedPlayerSettings === null || getSavedPlayerSettings === void 0 ? void 0 : getSavedPlayerSettings(PlayerSettings.Volume);
        var _recentMutedOption, _recentMutedOption1, _recentVolumeOption, ref;
        var state = {
            ready: false,
            fullscreen: false,
            playing: false,
            playedOnce: false,
            muted: (_recentMutedOption = NeauviaPlayerComponent.recentMutedOption) !== null && _recentMutedOption !== void 0 ? _recentMutedOption : false,
            unmutedOnce: !((_recentMutedOption1 = NeauviaPlayerComponent.recentMutedOption) !== null && _recentMutedOption1 !== void 0 ? _recentMutedOption1 : false),
            duration: 0,
            volume: (ref = (_recentVolumeOption = NeauviaPlayerComponent.recentVolumeOption) !== null && _recentVolumeOption !== void 0 ? _recentVolumeOption : savedVolume) !== null && ref !== void 0 ? ref : 1,
            playFrom: props.playFrom,
            disabled: false
        };
        if (props.autoPlay && props.video.source != null) {
            state.playing = true;
            var _recentMutedOption2;
            state.muted = (_recentMutedOption2 = NeauviaPlayerComponent.recentMutedOption) !== null && _recentMutedOption2 !== void 0 ? _recentMutedOption2 : true;
        }
        if (props.initialMuted) {
            state.muted = true;
        }
        // If there was stored miniplayer snapshot, initialize player using that snapshot's state.
        if (_this.props.miniplayerInitProps) {
            var _playing;
            state.playing = (_playing = _this.props.miniplayerInitProps.playing) !== null && _playing !== void 0 ? _playing : state.playing;
            var _playFrom;
            state.playFrom = (_playFrom = _this.props.miniplayerInitProps.playFrom) !== null && _playFrom !== void 0 ? _playFrom : state.playFrom;
            var _muted;
            state.muted = (_muted = _this.props.miniplayerInitProps.muted) !== null && _muted !== void 0 ? _muted : state.muted;
            var _volume;
            state.volume = (_volume = _this.props.miniplayerInitProps.volume) !== null && _volume !== void 0 ? _volume : state.volume;
        }
        state.playedOnce = state.playing;
        state.unmutedOnce = !state.muted;
        _this.state = state;
        if (_this.props.isInMiniplayer) {
            _this.props.attachMiniplayer(_this.onReturnFromMiniplayer);
        }
        return _this;
    }
    var _proto = NeauviaPlayerComponent.prototype;
    _proto.play = function play() {
        this.onPlay();
    };
    _proto.seekTo = function seekTo(to) {
        this.setState({
            playFrom: to
        });
    };
    _proto.mute = function mute() {
        this.onMute();
    };
    _proto.unmute = function unmute() {
        this.onUnmute();
    };
    _proto.componentDidMount = function componentDidMount() {
        if (this.props.isInMiniplayer) {
            this.props.attachMiniplayer(this.onReturnFromMiniplayer);
        }
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var _this = this;
        /*
      The code below covers an example use case where user was not logged in (hence absence of source)
      and has logged in (source was downloaded). If the player was set to autoPlay, then it should
      be auto played when the source becomes available.
     */ if (prevProps.video.source == null && this.props.video.source != null && this.props.autoPlay && !this.state.playing) {
            this.onPlay();
        }
        /*
      The code below covers a use case that only one player should be playing at the same time.
      There is an exception to TV player, which cannot be paused, so it should be muted instead.
     */ if (prevProps.isActivePlayer && !this.props.isActivePlayer && !this.state.muted && this.state.playing && !this.props.miniplayer) {
            if (this.props.playerId.includes(playerId/* PlayerId.TVLike */.z.TVLike)) {
                this.onMute(true);
            } else {
                this.onPause();
            }
        }
        /*
      The code below covers a use case that a TV miniplayer is closed without calling onReturn function.
      Players are paused when video is transferred to miniplayer, TV player is also paused - that is
      the only exception to TV player always playing. If miniplayer is closed in any way without resuming
      the TV player, we should force-resume it.
     */ if (prevProps.isInMiniplayer && !this.props.isInMiniplayer && !this.props.miniplayer && this.props.playerId.includes(playerId/* PlayerId.TVLike */.z.TVLike) && !this.state.playing) {
            this.onMute(true);
            setTimeout(function() {
                return _this.onPlay();
            }, 0);
        }
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.props.isInMiniplayer) {
            this.props.detachMiniplayer();
        }
    };
    _proto.render = function render() {
        var ref;
        var _props = this.props, video = _props.video, controls = _props.controls, ar = _props.ar, loop = _props.loop, wistiaOptions = _props.wistiaOptions, isInMiniplayer = _props.isInMiniplayer, miniplayer = _props.miniplayer, style = _props.style, className = _props.className;
        var _state = this.state, ready = _state.ready, playing = _state.playing, muted = _state.muted, volume = _state.volume, playedOnce = _state.playedOnce, unmutedOnce = _state.unmutedOnce, fullscreen = _state.fullscreen, duration = _state.duration, PlayerComponent = _state.PlayerComponent, hasError = _state.hasError, playFrom = _state.playFrom, disabled = _state.disabled;
        if (PlayerComponent == null) {
            return null;
        }
        var baseClassName = "neauvia-player swiper-restrict-swipe";
        var localClassName = className ? "".concat(baseClassName, " ").concat(className) : baseClassName;
        if (hasError) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(player_Container, {
                $ar: ar,
                style: style,
                className: localClassName,
                children: "Software failure"
            });
        }
        var ref1;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(player_Container, {
            $ar: ar,
            style: style,
            className: localClassName,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollHandle, {
                    ref: this.scrollHandleRef
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(PlayerComponent, {
                    innerRef: this.onInnerRef,
                    video: video,
                    playing: playing,
                    fullscreen: fullscreen,
                    muted: muted,
                    volume: volume,
                    loop: loop,
                    playedOnce: playedOnce,
                    playFrom: playFrom,
                    controls: (ref1 = controls === null || controls === void 0 ? void 0 : (ref = controls.native) === null || ref === void 0 ? void 0 : ref.enabled) !== null && ref1 !== void 0 ? ref1 : true,
                    miniplayer: miniplayer,
                    onReady: this.onReady,
                    onPlay: this.onPlay,
                    onPause: this.onPause,
                    onSeek: this.onSeek,
                    onEnded: this.onEnded,
                    onVolumeChange: this.onVolumeChange,
                    onMute: this.onMute,
                    onUnmute: this.onUnmute,
                    onEnterFullscreen: this.onEnterFullscreen,
                    onLeaveFullscreen: this.onLeaveFullscreen,
                    wistiaOptions: wistiaOptions,
                    children: !disabled && /*#__PURE__*/ (0,jsx_runtime.jsx)(OverlayController, {
                        video: video,
                        ready: ready,
                        playing: playing,
                        muted: muted,
                        unmutedOnce: unmutedOnce,
                        fullscreen: fullscreen,
                        miniplayer: miniplayer,
                        time$: this.time$,
                        duration: duration,
                        onPlay: this.onPlay,
                        onPause: this.onPause,
                        onUnmute: this.onUnmute,
                        onOpenMiniplayer: this.openInMiniplayer,
                        controls: controls
                    })
                }),
                isInMiniplayer && /*#__PURE__*/ (0,jsx_runtime.jsx)(MiniplayerInfoOverlay, {})
            ]
        });
    };
    NeauviaPlayerComponent.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
        var ref;
        var stateUpdate = {};
        stateUpdate.duration = ((ref = props.video.source) === null || ref === void 0 ? void 0 : ref.duration) != null ? iso8601ToSeconds(props.video.source.duration) : 0;
        var PlayerComponent = playerStrategyProvider(props.video.source);
        if (state.PlayerComponent !== PlayerComponent) {
            stateUpdate.PlayerComponent = PlayerComponent;
            /*
        If player changes, we cannot automatically turn on fullscreen, because enabling fullscreen
        requires a trusted event (like a mouse click). So we must deliberately disable it.
       */ stateUpdate.fullscreen = false;
        }
        stateUpdate.disabled = props.isInMiniplayer;
        if (stateUpdate.disabled) {
            stateUpdate.playing = false;
        }
        return stateUpdate;
    };
    NeauviaPlayerComponent.getDerivedStateFromError = function getDerivedStateFromError() {
        return {
            hasError: true
        };
    };
    (0,_create_class/* default */.Z)(NeauviaPlayerComponent, [
        {
            key: "stateSnapshot",
            get: function get() {
                var ref;
                var ref1;
                return {
                    ready: this.state.ready,
                    fullscreen: this.state.fullscreen,
                    playing: this.state.playing,
                    playedOnce: this.state.playedOnce,
                    volume: this.state.volume,
                    muted: this.state.muted,
                    unmutedOnce: this.state.unmutedOnce,
                    duration: this.state.duration,
                    time: (ref1 = (ref = this.playerApi) === null || ref === void 0 ? void 0 : ref.getCurrentTime()) !== null && ref1 !== void 0 ? ref1 : 0
                };
            }
        }
    ]);
    return NeauviaPlayerComponent;
}(react.PureComponent);
var _playerId, ref;
var usePlayerId = function(props) {
    var ref1;
    return (0,react.useMemo)(function() {
        var ref1;
        return (0,playerId/* playerIdFactory */.$)((_playerId = props.playerId) !== null && _playerId !== void 0 ? _playerId : playerId/* PlayerId.Common */.z.Common, (ref = (ref1 = props.video.source) === null || ref1 === void 0 ? void 0 : ref1.id) !== null && ref !== void 0 ? ref : props.video.id);
    }, [
        (ref1 = props.video.source) === null || ref1 === void 0 ? void 0 : ref1.id,
        props.video.id,
        props.playerId
    ]);
};
var useActivePlayer = function() {
    var dispatch = (0,es/* useDispatch */.I0)();
    var uuid = (0,hooks/* useUID */.D)();
    var isActivePlayer = (0,es/* useSelector */.v9)(selectActivePlayerId) === uuid;
    var setAsActivePlayer = (0,react.useCallback)(function() {
        return dispatch(actions/* AppAction.setActivePlayerId */.q.setActivePlayerId(uuid));
    }, [
        uuid,
        dispatch
    ]);
    return [
        isActivePlayer,
        setAsActivePlayer
    ];
};
// eslint-disable-next-line react/display-name
var NeauviaMiniplayerPlayer = /*#__PURE__*/ (0,react.memo)(/*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    var playerId = usePlayerId(props);
    var _$ref = (0,_sliced_to_array/* default */.Z)(useActivePlayer(), 2), isActivePlayer = _$ref[0], setAsActivePlayer = _$ref[1];
    var miniplayerCurrent = (0,es/* useSelector */.v9)(selectors/* selectMiniplayerCurrent */.kD);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(NeauviaPlayerComponent, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        ref: ref
    }, props), {
        playerId: playerId,
        miniplayer: true,
        isInMiniplayer: false,
        isActivePlayer: isActivePlayer,
        setAsActivePlayer: setAsActivePlayer,
        openMiniplayer: (noop_default()),
        attachMiniplayer: (noop_default()),
        detachMiniplayer: (noop_default()),
        resetMiniplayer: (noop_default()),
        miniplayerInitProps: miniplayerCurrent
    }));
}));
// eslint-disable-next-line react/display-name
var NeauviaPlayer = /*#__PURE__*/ (0,react.memo)(/*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    var store = (0,es/* useStore */.oR)();
    var dispatch = (0,es/* useDispatch */.I0)();
    var playerId = usePlayerId(props);
    var _$ref = (0,_sliced_to_array/* default */.Z)(useActivePlayer(), 2), isActivePlayer = _$ref[0], setAsActivePlayer = _$ref[1];
    var miniplayerCurrent = (0,es/* useSelector */.v9)(selectors/* selectMiniplayerCurrent */.kD);
    var isInMiniplayer = (miniplayerCurrent === null || miniplayerCurrent === void 0 ? void 0 : miniplayerCurrent.playerId) === playerId;
    var openMiniplayer = (0,react.useCallback)(function(state) {
        var _$ref;
        (_$ref = props.onOpenMiniplayer) === null || _$ref === void 0 ? void 0 : _$ref.call(props);
        dispatch(actions/* AppAction.openMiniplayer */.q.openMiniplayer(state));
    }, [
        props,
        dispatch
    ]);
    var attachMiniplayer = (0,react.useCallback)(function(onReturn) {
        return dispatch(actions/* AppAction.attachMiniplayer */.q.attachMiniplayer(onReturn));
    }, [
        dispatch
    ]);
    var detachMiniplayer = (0,react.useCallback)(function() {
        return dispatch(actions/* AppAction.detachMiniplayer */.q.detachMiniplayer({}));
    }, [
        dispatch
    ]);
    var resetMiniplayer = (0,react.useCallback)(function() {
        return dispatch(actions/* AppAction.resetMiniplayer */.q.resetMiniplayer({}));
    }, [
        dispatch
    ]);
    /*
      The below code should run only once on component initialization.
      It checks whether there is stored snapshot related to player that is being created.
     *
      The player must not be a miniplayer instance.
     *
      If snapshot exists and matches by playerId, it will be memoized locally,
      removed from store and passed to NeauviaPlayerComponent constructor.
     */ var _$ref1 = (0,react.useState)(function() {
        var currentSnapshot = store.getState().miniplayer.snapshot;
        if ((currentSnapshot === null || currentSnapshot === void 0 ? void 0 : currentSnapshot.playerId) === playerId) {
            dispatch(actions/* AppAction.resetMiniplayer */.q.resetMiniplayer({}));
            return currentSnapshot;
        }
    }), miniplayerSnapshot = _$ref1[0];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(NeauviaPlayerComponent, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        ref: ref
    }, props), {
        playerId: playerId,
        miniplayer: false,
        isInMiniplayer: isInMiniplayer,
        isActivePlayer: isActivePlayer,
        setAsActivePlayer: setAsActivePlayer,
        openMiniplayer: openMiniplayer,
        attachMiniplayer: attachMiniplayer,
        detachMiniplayer: detachMiniplayer,
        resetMiniplayer: resetMiniplayer,
        miniplayerInitProps: miniplayerSnapshot
    }));
}));
var NeauviaPlayerLayer = (0,styled_components_browser_esm["default"])(NeauviaPlayer).withConfig({
    displayName: "player__NeauviaPlayerLayer",
    componentId: "sc-567d0ac2-2"
})(player_templateObject3(), common/* layer */.EY);


/***/ }),

/***/ 97113:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ Fade; },
/* harmony export */   "x": function() { return /* binding */ HealthcareLegalConsentOverlay; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react_t7e__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(17739);
/* harmony import */ var react_t7e__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(react_t7e__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(81041);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(14332);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82580);
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(74231);
/* harmony import */ var src_components_player_common__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(33578);
/* harmony import */ var src_utils_motion_transitions__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(84176);
/* harmony import */ var vendor_mods_styled_components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(10395);
/* harmony import */ var src_styles_theme__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(68251);
/* harmony import */ var src_components_common_Layers__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(25001);
/* harmony import */ var src_components_common_Checkbox__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(74003);
/* harmony import */ var vendor_mods_markdown_components_Markdown__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(15201);
/* harmony import */ var src_components_common_Button__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(78296);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(87379);
/* harmony import */ var src_styles_common__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(12258);
/* harmony import */ var polished__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(17573);
/* harmony import */ var src_styles_designs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(73098);
/* harmony import */ var src_hooks_useUserHealthcareLegalConsent__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(32962);
/* harmony import */ var src_hooks_consents_useRegistrationFormLegalNoticesQuery__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(16455);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        ";\n  z-index: ",
        ";\n  background: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-weight: 300;\n  font-size: 21px;\n  line-height: 130%;\n  letter-spacing: 0.02em;\n  color: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: grid;\n  grid-template-areas: 'header' 'consent' 'button';\n  width: 271px;\n  gap: 30px;\n  white-space: normal;\n\n  ",
        " {\n    width: 371px;\n    --base-unit: 100vw / 560;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  z-index: ",
        ";\n\n  ",
        " {\n    direction: rtl;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  z-index: ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}




















var Fade = (0,framer_motion__WEBPACK_IMPORTED_MODULE_17__/* .motion */ .E)(styled_components__WEBPACK_IMPORTED_MODULE_18__["default"].div.withConfig({
    displayName: "HealthcareLegalConsentOverlay__Fade",
    componentId: "sc-8594bc75-0"
})(_templateObject(), src_styles_common__WEBPACK_IMPORTED_MODULE_13__/* .layer */ .EY, src_components_player_common__WEBPACK_IMPORTED_MODULE_5__/* .playerFadeZIndex */ .PO, function(param) {
    var theme = param.theme;
    return (0,polished__WEBPACK_IMPORTED_MODULE_19__/* .transparentize */ .DZ)(0.15, theme.palette.background);
}));
var ContentHeader = styled_components__WEBPACK_IMPORTED_MODULE_18__["default"].div.withConfig({
    displayName: "HealthcareLegalConsentOverlay__ContentHeader",
    componentId: "sc-8594bc75-1"
})(_templateObject1(), (0,src_styles_theme__WEBPACK_IMPORTED_MODULE_8__/* .fromTheme */ .HW)(function(t) {
    return t.text.palette.heavy;
}));
var ConsentBlock = (0,styled_components__WEBPACK_IMPORTED_MODULE_18__["default"])(framer_motion__WEBPACK_IMPORTED_MODULE_17__/* .motion.div */ .E.div).withConfig({
    displayName: "HealthcareLegalConsentOverlay__ConsentBlock",
    componentId: "sc-8594bc75-2"
})(_templateObject2(), src_styles_designs__WEBPACK_IMPORTED_MODULE_14__/* .media.w.lessThan.desktop */ .BC.w.lessThan.desktop);
var StyledOverlayLayer = (0,styled_components__WEBPACK_IMPORTED_MODULE_18__["default"])(src_components_player_common__WEBPACK_IMPORTED_MODULE_5__/* .OverlayLayer */ .s2).withConfig({
    displayName: "HealthcareLegalConsentOverlay__StyledOverlayLayer",
    componentId: "sc-8594bc75-3"
})(_templateObject3(), src_components_player_common__WEBPACK_IMPORTED_MODULE_5__/* .playerOverlayAboveControlsZIndex */ ._R, src_styles_theme__WEBPACK_IMPORTED_MODULE_8__/* .dirRTL */ .gX);
var StyledCenteredContent = (0,styled_components__WEBPACK_IMPORTED_MODULE_18__["default"])(src_components_common_Layers__WEBPACK_IMPORTED_MODULE_9__/* .CenteredContent */ .K).withConfig({
    displayName: "HealthcareLegalConsentOverlay__StyledCenteredContent",
    componentId: "sc-8594bc75-4"
})(_templateObject4(), src_components_player_common__WEBPACK_IMPORTED_MODULE_5__/* .playerFadeZIndex */ .PO + 1);
var HealthcareLegalConsentOverlay = function(param) {
    var onPlay = param.onPlay, onUnmute = param.onUnmute, backgroundOnly = param.backgroundOnly, onBackgroundClick = param.onBackgroundClick;
    var ref;
    var _ = (0,react_t7e__WEBPACK_IMPORTED_MODULE_20__.useTranslate)()._;
    var ref1 = (0,src_hooks_useUserHealthcareLegalConsent__WEBPACK_IMPORTED_MODULE_15__/* .useUserHealthcareLegalConsent */ .P)(), healthcareProfessionalKey = ref1.healthcareProfessionalKey, setSessionConsents = ref1.setSessionConsents, userConsentValue = ref1.userConsentValue;
    var saveConsent = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function() {
        setSessionConsents(true);
        onPlay();
        onUnmute();
    }, [
        onPlay,
        onUnmute,
        setSessionConsents
    ]);
    var legalNotices = (0,src_hooks_consents_useRegistrationFormLegalNoticesQuery__WEBPACK_IMPORTED_MODULE_16__/* .useRegistrationFormLegalNoticesQuery */ .K)();
    var notice = (ref = legalNotices.data) === null || ref === void 0 ? void 0 : ref.find(function(t) {
        return t.identifier === healthcareProfessionalKey;
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_21__/* .AnimatePresence */ .M, {
        initial: false,
        children: notice && !userConsentValue ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(formik__WEBPACK_IMPORTED_MODULE_3__/* .Formik */ .J9, {
            onSubmit: saveConsent,
            validationSchema: yup__WEBPACK_IMPORTED_MODULE_4__/* .object */ .Ry((0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)({}, healthcareProfessionalKey, yup__WEBPACK_IMPORTED_MODULE_4__/* .boolean */ .O7().isTrue(_("Required")).required(_("Required")))),
            initialValues: (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)({}, healthcareProfessionalKey, userConsentValue),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(formik__WEBPACK_IMPORTED_MODULE_3__/* .Form */ .l0, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledOverlayLayer, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z)({}, (0,src_utils_motion_transitions__WEBPACK_IMPORTED_MODULE_6__/* .makeTransition */ .Vr)({
                    fade: true
                })), {
                    as: framer_motion__WEBPACK_IMPORTED_MODULE_17__/* .motion.div */ .E.div,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(vendor_mods_styled_components__WEBPACK_IMPORTED_MODULE_7__/* .Theme */ .Q, {
                        theme: src_styles_theme__WEBPACK_IMPORTED_MODULE_8__/* .darkTheme */ .$_,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Fade, {
                                onClick: onBackgroundClick
                            }),
                            !backgroundOnly && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledCenteredContent, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z)({}, (0,src_utils_motion_transitions__WEBPACK_IMPORTED_MODULE_6__/* .makeTransition */ .Vr)({
                                from: "top",
                                to: "bottom"
                            })), {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(ConsentBlock, {
                                    className: "player__consent-block",
                                    layout: true,
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ContentHeader, {
                                            children: _("MEDICAL CONTENT CONFIRMATION OF PROFESSION REQUIRED")
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_components_common_Checkbox__WEBPACK_IMPORTED_MODULE_10__/* .CheckboxFormik */ .v, {
                                            name: healthcareProfessionalKey,
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(vendor_mods_markdown_components_Markdown__WEBPACK_IMPORTED_MODULE_11__/* .Markdown */ .U, {
                                                children: notice.content
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_components_common_Button__WEBPACK_IMPORTED_MODULE_12__/* .Button */ .zx, {
                                            type: "submit",
                                            children: _("CONFIRM AND WATCH")
                                        })
                                    ]
                                })
                            }))
                        ]
                    })
                }))
            })
        }) : null
    });
};


/***/ }),

/***/ 19295:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ playerIdFactory; },
/* harmony export */   "z": function() { return /* binding */ PlayerId; }
/* harmony export */ });
var PlayerId;
(function(PlayerId) {
    PlayerId["Common"] = "common";
    PlayerId["TVLike"] = "tvLike";
})(PlayerId || (PlayerId = {}));
var playerIdFactory = function(playerId, objectId) {
    if (playerId === PlayerId.TVLike) {
        return PlayerId.TVLike;
    }
    return "".concat(playerId !== null && playerId !== void 0 ? playerId : PlayerId.Common, "__").concat(objectId);
};


/***/ }),

/***/ 16455:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ useRegistrationFormLegalNoticesQuery; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88767);
/* harmony import */ var src_models_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19162);
/* harmony import */ var src_hooks_useAPIs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53100);
/* harmony import */ var src_utils_queryCommonOptions__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(57750);






var useRegistrationFormLegalNoticesQuery = function() {
    var apis = (0,src_hooks_useAPIs__WEBPACK_IMPORTED_MODULE_2__/* .useAPIs */ .V)();
    return (0,react_query__WEBPACK_IMPORTED_MODULE_0__.useQuery)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, src_utils_queryCommonOptions__WEBPACK_IMPORTED_MODULE_3__/* .longStaleQueryBase */ .R), {
        queryKey: src_models_query__WEBPACK_IMPORTED_MODULE_1__/* .QueryKey.RegistrationLegalNotices */ .S.RegistrationLegalNotices,
        queryFn: function() {
            return apis.identityExtensions.legal.notices.registration();
        }
    }));
};


/***/ }),

/***/ 32962:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ useUserHealthcareLegalConsent; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(828);
/* harmony import */ var src_hooks_useSynchronizedLocalStorage__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27336);
/* harmony import */ var src_modules_user_hooks_useUserQuery__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(44320);



/**
 * userConsentValue: Returns true if user has accepted "healthcareProfessional"
 * consent via session checkbox or in registration form.
 */ function useUserHealthcareLegalConsent() {
    var ref;
    var healthcareProfessional = (ref = (0,src_modules_user_hooks_useUserQuery__WEBPACK_IMPORTED_MODULE_1__/* .useUserQuery */ .b)().data) === null || ref === void 0 ? void 0 : ref.identity.traits.preferencesSetter.healthcareProfessional;
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,src_hooks_useSynchronizedLocalStorage__WEBPACK_IMPORTED_MODULE_0__/* .useSynchronizedLocalStorage */ .O)("healthcareProfessional", false), 2), sessionConsents = ref1[0], setSessionConsents = ref1[1];
    var userConsentValue = healthcareProfessional || sessionConsents;
    return {
        healthcareProfessionalKey: "healthcareProfessional",
        setSessionConsents: setSessionConsents,
        userConsentValue: userConsentValue
    };
}


/***/ }),

/***/ 47573:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bq": function() { return /* binding */ CloseModalWrapper; },
/* harmony export */   "IM": function() { return /* binding */ ModalInner; },
/* harmony export */   "Iu": function() { return /* binding */ FormPadding; },
/* harmony export */   "WI": function() { return /* binding */ FormArea; },
/* harmony export */   "fM": function() { return /* binding */ CloseModalButton; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(87379);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(81041);
/* harmony import */ var src_styles_designs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73098);
/* harmony import */ var src_components_common_Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78296);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var src_components_common_ModalControllerContext__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(19659);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: grid;\n  position: absolute;\n  top: 0;\n  // For use in fullscreen modals to prevent layout shifting in browsers without overlay scrollbar\n  left: calc(var(--scrollbar-padding) * -1);\n  right: 0;\n  bottom: 0;\n\n  grid-template-columns: 1fr 400px 1fr;\n  grid-template-rows: 1fr min-content 1fr;\n  grid-template-areas:\n    '. . .'\n    '. content .'\n    '. . .';\n\n  ",
        " {\n    position: relative;\n    height: 100%;\n    left: 0;\n    grid-template-columns: 1fr;\n    grid-template-rows: min-content minmax(0, 1fr);\n    grid-template-areas:\n      'header'\n      'content';\n    background: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  grid-area: content;\n  margin-bottom: auto;\n  margin-top: auto;\n  max-height: 100%;\n  height: 100%;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 10px;\n\n  ",
        " {\n    padding: 20px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  && {\n    position: absolute;\n    right: 10vw;\n    top: 9vh;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}







var ModalInner = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__["default"])(framer_motion__WEBPACK_IMPORTED_MODULE_7__/* .motion.div */ .E.div).withConfig({
    displayName: "common__ModalInner",
    componentId: "sc-94dd7b1f-0"
})(_templateObject(), src_styles_designs__WEBPACK_IMPORTED_MODULE_2__/* .media.w.lessThan.desktop */ .BC.w.lessThan.desktop, function(param) {
    var theme = param.theme;
    return theme.palette.background;
});
var FormArea = styled_components__WEBPACK_IMPORTED_MODULE_6__["default"].div.withConfig({
    displayName: "common__FormArea",
    componentId: "sc-94dd7b1f-1"
})(_templateObject1());
var FormPadding = (0,framer_motion__WEBPACK_IMPORTED_MODULE_7__/* .motion */ .E)(styled_components__WEBPACK_IMPORTED_MODULE_6__["default"].div.withConfig({
    displayName: "common__FormPadding",
    componentId: "sc-94dd7b1f-2"
})(_templateObject2(), src_styles_designs__WEBPACK_IMPORTED_MODULE_2__/* .media.w.lessThan.desktop */ .BC.w.lessThan.desktop));
var CloseModalButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__["default"])(src_components_common_Button__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .zx).withConfig({
    displayName: "common__CloseModalButton",
    componentId: "sc-94dd7b1f-3"
})(_templateObject3());
var CloseModalWrapper = function(param) {
    var children = param.children;
    var close = (0,react__WEBPACK_IMPORTED_MODULE_4__.useContext)(src_components_common_ModalControllerContext__WEBPACK_IMPORTED_MODULE_5__/* .ModalControllerContext */ .L).close;
    return close ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_4__.cloneElement)(children, {
            onClick: close
        })
    }) : null;
};


/***/ }),

/***/ 45522:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "C": function() { return /* binding */ VideoSummary; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 6 modules
var polished_esm = __webpack_require__(17573);
// EXTERNAL MODULE: ./src/modules/user/components/Avatar.tsx + 2 modules
var Avatar = __webpack_require__(43029);
// EXTERNAL MODULE: ./src/hooks/directus/useTranslateItem.ts
var useTranslateItem = __webpack_require__(70057);
;// CONCATENATED MODULE: ./src/modules/materials/components/SpeakerCard.tsx



function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-template-areas: 'avatar name' 'avatar title';\n  grid-template-columns: 28px 1fr;\n  grid-column-gap: 10px;\n  align-items: center;\n  grid-row-gap: 3px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-area: avatar;\n  min-width: 0;\n  width: 100%;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-area: name;\n  font-style: normal;\n  font-weight: 500;\n  font-size: 12px;\n  line-height: 16px;\n  min-width: 0;\n  ",
        ";\n  align-self: flex-end;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-area: title;\n  font-style: normal;\n  font-weight: 300;\n  font-size: 12px;\n  line-height: 16px;\n  min-width: 0;\n  ",
        ";\n  align-self: flex-start;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}






var Container = styled_components_browser_esm["default"].div.withConfig({
    displayName: "SpeakerCard__Container",
    componentId: "sc-6b830456-0"
})(_templateObject());
var StyledAvatar = (0,styled_components_browser_esm["default"])(Avatar/* Avatar */.qE).withConfig({
    displayName: "SpeakerCard__StyledAvatar",
    componentId: "sc-6b830456-1"
})(_templateObject1());
var Name = styled_components_browser_esm["default"].span.withConfig({
    displayName: "SpeakerCard__Name",
    componentId: "sc-6b830456-2"
})(_templateObject2(), (0,polished_esm/* ellipsis */.LH)("100%"));
var Title = styled_components_browser_esm["default"].span.withConfig({
    displayName: "SpeakerCard__Title",
    componentId: "sc-6b830456-3"
})(_templateObject3(), (0,polished_esm/* ellipsis */.LH)("100%"));
var SpeakerCard = function(param) {
    var speaker = param.speaker;
    var ref;
    var translateItem = (0,useTranslateItem/* useTranslateItem */.L)();
    var preparedSpeaker = (0,react.useMemo)(function() {
        var ref;
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, translateItem(speaker)), {
            country: speaker.country ? (ref = translateItem(speaker.country)) === null || ref === void 0 ? void 0 : ref.name : undefined
        });
    }, [
        speaker
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledAvatar, {
                src: (ref = preparedSpeaker.avatar) === null || ref === void 0 ? void 0 : ref.id
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Name, {
                children: [
                    preparedSpeaker.degree ? "".concat(preparedSpeaker.degree, " ") : "",
                    preparedSpeaker.name
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Title, {
                children: [
                    preparedSpeaker.title,
                    preparedSpeaker.country ? " - ".concat(preparedSpeaker.country) : ""
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/styles/common.ts
var common = __webpack_require__(12258);
// EXTERNAL MODULE: ./src/components/common/Button/index.tsx + 8 modules
var Button = __webpack_require__(78296);
// EXTERNAL MODULE: ./src/components/icons/ChevronBottom.tsx
var ChevronBottom = __webpack_require__(56647);
// EXTERNAL MODULE: ./src/styles/designs.ts
var designs = __webpack_require__(73098);
// EXTERNAL MODULE: ./src/components/TrackedLink.tsx
var TrackedLink = __webpack_require__(79017);
// EXTERNAL MODULE: ./node_modules/react-t7e/lib/index.js
var lib = __webpack_require__(17739);
// EXTERNAL MODULE: ./src/services/route.ts + 1 modules
var route = __webpack_require__(38325);
;// CONCATENATED MODULE: ./src/modules/videos/components/VideoSummary.tsx




function VideoSummary_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: start;\n  height: 100%;\n  row-gap: 12px;\n  color: ",
        ";\n"
    ]);
    VideoSummary_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function VideoSummary_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  min-height: 0;\n\n  ",
        " {\n    display: flex;\n    align-items: start;\n    justify-content: space-between;\n  }\n"
    ]);
    VideoSummary_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function VideoSummary_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n  max-height: 100%;\n  font-style: normal;\n  font-weight: 300;\n  font-size: 16px;\n  line-height: 110%;\n  letter-spacing: 0.02em;\n  text-transform: uppercase;\n\n  ",
        " {\n    font-size: 26px;\n  }\n  ",
        " {\n    margin-top: 2px;\n  }\n"
    ]);
    VideoSummary_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function VideoSummary_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-style: normal;\n  font-weight: 300;\n  font-size: 14px;\n  line-height: 18px;\n  min-height: 0;\n\n  ",
        " {\n    display: none;\n  }\n"
    ]);
    VideoSummary_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n  max-height: 100%;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-template-columns: repeat(2, fit-content(75%));\n  grid-column-gap: 8px;\n  grid-template-rows: auto;\n  min-height: 0;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-style: normal;\n  font-weight: normal;\n  font-size: 12px;\n  line-height: 18px;\n  min-width: 0;\n  ",
        ";\n  ",
        ";\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-template-rows: auto auto;\n  grid-template-columns: 100%;\n  grid-row-gap: 6px;\n  min-height: 0;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  margin-top: auto;\n  font-style: normal;\n  font-weight: normal;\n  font-size: 10px;\n  line-height: 16px;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n  align-self: flex-end;\n\n  ",
        " {\n    display: none;\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-grow: 0;\n  flex-shrink: 0;\n  margin-left: 10px;\n\n  ",
        " {\n    display: none;\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}













var VideoSummary_Container = styled_components_browser_esm["default"].aside.withConfig({
    displayName: "VideoSummary__Container",
    componentId: "sc-51df0ab6-0"
})(VideoSummary_templateObject(), function(props) {
    return props.theme.text.palette.primary;
});
var Header = styled_components_browser_esm["default"].header.withConfig({
    displayName: "VideoSummary__Header",
    componentId: "sc-51df0ab6-1"
})(VideoSummary_templateObject1(), designs/* media.w.lessThan.desktop */.BC.w.lessThan.desktop);
var HeaderContent = styled_components_browser_esm["default"].h2.withConfig({
    displayName: "VideoSummary__HeaderContent",
    componentId: "sc-51df0ab6-2"
})(VideoSummary_templateObject2(), (0,common/* lineClamp */.Sf)(3), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop, designs/* media.w.lessThan.desktop */.BC.w.lessThan.desktop);
var Description = styled_components_browser_esm["default"].div.withConfig({
    displayName: "VideoSummary__Description",
    componentId: "sc-51df0ab6-3"
})(VideoSummary_templateObject3(), designs/* media.w.lessThan.desktop */.BC.w.lessThan.desktop);
var DescriptionContent = styled_components_browser_esm["default"].div.withConfig({
    displayName: "VideoSummary__DescriptionContent",
    componentId: "sc-51df0ab6-4"
})(_templateObject4(), (0,common/* lineClamp */.Sf)(4));
var Tags = styled_components_browser_esm["default"].div.withConfig({
    displayName: "VideoSummary__Tags",
    componentId: "sc-51df0ab6-5"
})(_templateObject5());
var Tag = styled_components_browser_esm["default"].span.withConfig({
    displayName: "VideoSummary__Tag",
    componentId: "sc-51df0ab6-6"
})(_templateObject6(), function(props) {
    return props.theme.text.palette.secondary;
}, (0,polished_esm/* ellipsis */.LH)("100%"), (0,polished_esm/* wordWrap */.BW)("nowrap"));
var Speakers = styled_components_browser_esm["default"].div.withConfig({
    displayName: "VideoSummary__Speakers",
    componentId: "sc-51df0ab6-7"
})(_templateObject7());
var Footer = styled_components_browser_esm["default"].footer.withConfig({
    displayName: "VideoSummary__Footer",
    componentId: "sc-51df0ab6-8"
})(_templateObject8(), designs/* media.w.lessThan.desktop */.BC.w.lessThan.desktop);
var MobileMoreButton = (0,styled_components_browser_esm["default"])(Button/* Button */.zx).withConfig({
    displayName: "VideoSummary__MobileMoreButton",
    componentId: "sc-51df0ab6-9"
})(_templateObject9(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var VideoSummary = function(_param) {
    var video = _param.video, _moreButton = _param.moreButton, moreButton = _moreButton === void 0 ? true : _moreButton, props = (0,_object_without_properties/* default */.Z)(_param, [
        "video",
        "moreButton"
    ]);
    var _ = (0,lib.useTranslate)()._;
    var translateItem = (0,useTranslateItem/* useTranslateItem */.L)();
    var ref = translateItem(video), name = ref.name, description = ref.description, tags = ref.tags, speakers = ref.speakers;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(VideoSummary_Container, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Header, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderContent, {
                        children: name
                    }),
                    moreButton && /*#__PURE__*/ (0,jsx_runtime.jsx)(TrackedLink/* TrackedLink */.A, {
                        href: route/* route.video */.BC.video(video).page(),
                        passHref: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileMoreButton, {
                            forwardedAs: "a",
                            kind: "text",
                            variant: "secondary",
                            icon: ChevronBottom/* ChevronBottom */.B
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Description, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DescriptionContent, {
                    children: description
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tags, {
                children: tags.slice(0, 4).map(function(a) {
                    return a.tags_id;
                }).map(translateItem).map(function(a) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tag, {
                        children: a.name
                    }, a.id);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Speakers, {
                children: speakers.map(function(a) {
                    return a.people_id;
                }).slice(0, 2).map(function(a) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SpeakerCard, {
                        speaker: a
                    }, a.id);
                })
            }),
            moreButton && /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TrackedLink/* TrackedLink */.A, {
                    href: route/* route.video */.BC.video(video).page(),
                    passHref: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.zx, {
                        as: "a",
                        kind: "text",
                        variant: "secondary",
                        icon: ChevronBottom/* ChevronBottom */.B,
                        children: _("More")
                    })
                })
            })
        ]
    }));
};


/***/ }),

/***/ 95406:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ix": function() { return /* binding */ selectMiniplayerOnReturn; },
/* harmony export */   "kD": function() { return /* binding */ selectMiniplayerCurrent; }
/* harmony export */ });
/* unused harmony export selectMiniplayerState */
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68697);

var selectMiniplayerState = function(store) {
    return store.miniplayer;
};
var selectMiniplayerCurrent = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__/* .createSelector */ .P1)(selectMiniplayerState, function(state) {
    return state.current;
});
var selectMiniplayerOnReturn = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__/* .createSelector */ .P1)(selectMiniplayerState, function(state) {
    return state.onReturn;
});


/***/ }),

/***/ 45402:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ withSilentErrorBoundary; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_error_boundary__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35800);
/* harmony import */ var react_error_boundary__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_error_boundary__WEBPACK_IMPORTED_MODULE_1__);


/**
 * Ignore component if it throws an error during rendering.
 * @constructor
 */ var RenderNothing = function() {
    return null;
};
var withSilentErrorBoundary = function(Component) {
    return (0,react_error_boundary__WEBPACK_IMPORTED_MODULE_1__.withErrorBoundary)(Component, {
        FallbackComponent: RenderNothing,
        onError: function onError(e) {
            console.error("[withSilentErrorBoundary]", e);
        }
    });
};


/***/ })

}]);